/* eslint-disable no-undef */
import { DatePicker, Tabs, Tooltip } from "antd";
import "antd/dist/antd.css";
import "./custom.css";
import axios from "axios";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import moment from "moment";
import { toast } from "react-toastify";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  CustomerDashboardTable,
  Icon,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { getCurrencyIcon } from "../../../utils/getCurrencyIcon";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import styled from "styled-components";
import { AllowAccess } from "../../../components/BlockAccess";
import { VerifyBvnModal } from "./VerifyBvnModal";

const dateFormat = "YYYY-MM-DD";

export const CustomerDashboard = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
    type: false,
    individual: false,
    corporate: false,
    investment: false,
    director: false,
  });
  const [verifyBvnModal, setVerifyBvnModal] = useState(false);
  // const [customertype, setCustomerType] = useState({
  //   individual: false,
  // });
  // const referralCode = JSON.parse(localStorage.getItem("referralCode"));
  const [editId, setEditedId] = useState();
  const [conValue, setConValue] = useState("targetAmount");
  const [formData, setFormData] = useState({
    bvn: "",
    email: "",
    firstName: "",
    lastName: "",
    middleName: "",
    source: "ROSABON_SALES",
    creationSource: "BACKEND",
    platform: "TREASURY",
    accountName: "N/A for admins",
  });
  const [companyFormData, setCompanyFormData] = useState({
    source: "ROSABON_SALES",
    platform: "TREASURY",
    creationSource: "BACKEND",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [customerDashboard, setCustomerDashboard] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [details, setDetails] = useState();
  const [singleDirectorDetail, setSingleDirectorDetail] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [total, setTotal] = useState();
  // const [page, setPage] = useState(0);
  const [products, setProducts] = useState([]);
  const [singleProduct, setSingleProduct] = useState({});
  const [exchangeRates, setExchangeRates] = useState([]);
  const [validSavingsFreq, setValidSavingsFreq] = useState(true);
  const [computeInvestment, setComputeInvestment] = useState(false);
  const [investMsg, setInvestMsg] = useState(null);
  const [docView, setDocView] = useState();
  const [reactivateReason, setReactivateReason] = useState("");
  const [isReactivateLoading, setIsReactivateLoading] = useState(false);
  const [companyEmail, setCompanyEmail] = useState("");
  const [isAoLoading, setIsAoLoading] = useState(false);

  let date = new Date();

  const createInvestmentInitialForm = {
    acceptPeriodicContribution: true,
    actualMaturityDate: "",
    allowsLiquidation: false,
    amount: 0,
    approvalConcessionDocumentImage: "",
    autoRenew: false,
    autoRollOver: false,
    contributionValue: 0,
    currency: "",
    dateCreated: moment(date).format("YYYY-MM-DD"),
    directDebit: false,
    exchangeRate: 1,
    interestRate: "",
    interestRateConcession: "",
    interestReceiptOption: "",
    investmentValueDate: "",
    monthlyContributionDay: 1,
    numberOfTickets: 0,
    paymentMethod: null,
    paymentProofImage: "",
    planDate: moment(date).format("YYYY-MM-DD"),
    planName: "",
    planStatus: "PENDING",
    planSummary: {},
    product: "",
    productCategory: "",
    requestConcession: false,
    savingFrequency: null,
    targetAmount: 0,
    tenor: null,
    toppingUp: false,
    weeklyContributionDay: "MONDAY",
  };

  const initFileErr = {
    approvalConcessionDocumentImage: false,
    paymentProofImage: false,
  };

  const [fileErr, setFileErr] = useState(initFileErr);

  // create investment validation state
  const [touched, setTouched] = useState(false);

  const [createInvestmentFormData, setCreateInvestmentFormData] = useState(createInvestmentInitialForm);
  const [withholding_tax, setWithholding_tax] = useState([]);
  const [search, setSearch] = useState("");


  const [handleEditLoading,sethandleEditLoading] = useState(false)

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getCustomerDash();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const checkAtMaturity =
    createInvestmentFormData.actualMaturityDate &&
    (createInvestmentFormData.tenor === 0 || createInvestmentFormData.tenor === null);

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onCompanyInputChange = (e) => {
    setCompanyFormData({ ...companyFormData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setIsLoadBtn(false);
    setFormData({
      bvn: "",
      email: "",
      firstName: "",
      lastName: "",
      middleName: "",
      source: "ROSABON_SALES",
      creationSource: "BACKEND",
    });
    setDetails(undefined);
    setDirectorDetail(undefined);
    setCompanyDocument(undefined);
    setCustomerEmail(undefined);
    setbvnVerified(false);
    setCompanyFormData(undefined);
    setUserBankDetails(undefined);
    setOfficerIndex(undefined);
  };

  const [countries, setCountries] = useState();
  const getCountries = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/country`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      if (resultData) {
        setCountries(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [banks, setBanks] = useState();
  const getBanks = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/bank-account/get-all-banks`, {
        headers: authHeader(),
      });
      const resultData = await response.data.data;
      if (resultData) {
        setBanks(resultData);
      }
      return { formData };
    } catch (error) {}
  };

  const [accountOfficers, setaccountOfficers] = useState();
  const getaccountOfficers = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/account-officer`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      if (resultData) {
        setaccountOfficers(resultData);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [states, setStates] = useState();
  const getStates = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/state/${id}`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      if (resultData) {
        setStates(resultData);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [lgas, setLGAs] = useState();
  const getLGAs = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/lga/${id}`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      if (resultData) {
        setLGAs(resultData);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [genders, setGender] = useState();
  const getGender = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/gender`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      const filteredGenders = resultData.filter((data) => data.status === "ACTIVE");
      if (resultData) {
        setGender(filteredGenders);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [idType, setIDType] = useState();
  const getIDType = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/identification-type`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      if (resultData) {
        setIDType(resultData.filter((data) => data.status === "ACTIVE"));
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [totalPages, settotalPages] = useState();
  const getCustomerDash = async (page) => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/customer-details?${
          search ? `search=${search}&` : ""
        }usage=TREASURY${page ? `&page=${page}` : "&page=0"}`,
        {
          headers: authHeader(),
        }
      );
      const resultData = await response.data;
      setTotal(resultData?.total);
      if (resultData) {
        setCustomerDashboard(resultData.entities);
        settotalPages(resultData.total);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getSingleCustomer = async (items) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/customer-details/${items.id}`,
        {
          headers: authHeader(),
        }
      );
      const resultData = await response.data;
      if (resultData) {
        setDetails(resultData);
        getStates(resultData?.countryOfResidence?.id);
        getBankDetails(resultData);
        // console.log(resultData.state)
      }
      return { formData };
    } catch (error) {}
  };

  const getSingleCompany = async (items) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/company/${items.id}`,
        {
          headers: authHeader(),
        }
      );
      const resultData = await response.data;
      if (resultData) {
        setDetails(resultData);
      }
      return { formData };
    } catch (error) {}
  };

  const [customerEmail, setCustomerEmail] = useState();
  // function encodeProfilePic(element) {
  //   var file = element.target.files[0];
  //   var filename = file.name;
  //   var reader = new FileReader();
  //   reader.onloadend = function () {
  //     const res = reader.result;
  //     if (res) {
  //       const fileArr = res.split("base64,");
  //       let url = fileArr[1];
  //       setFormData({
  //         ...formData,
  //         [element.target.name]: url,
  //       });
  //     }
  //   };
  //   reader.readAsDataURL(file);
  // }
  const addCustomerDash = async (obj) => {
    const data = {
      ...obj,
      address: {
        city: formData.city,
        nationality: formData.nationality,
        houseNoAddress: formData.houseNoAddress,
        state: formData.state,
      },
      platform: "TREASURY",
    };
    setIsLoadBtn(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/personal-info`,
        data,
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        setIsLoadBtn(false);
        setCustomerEmail(data.email);
        setModal({ employmentDetail: true });
      }
      return { formData };
    } catch (error) {
      setIsLoadBtn(false);
      const message = error.response;
      toast.error(message.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const [bvnVerified, setbvnVerified] = useState(false);
  const verifyBVN = async (userType) => {
    console.log(formData);
    console.log(userType);
    if (!formData.bvn || !formData?.dateOfBirth || !formData?.primaryPhoneNumber) {
      toast.error("Enter Date of birth and phone number");
      return;
    }
    const data = {
      id: formData?.bvn,
      dateOfBirth: formData?.dateOfBirth,
      phoneNumber: formData?.primaryPhoneNumber,
      isSubjectConsent: true,
    };

    const cdata = {
      id: formData?.bvn,
      dateOfBirth: formData?.dateOfBirth,
      phoneNumber: formData?.primaryPhoneNumber,
      isSubjectConsent: true,
    };

    try {
      console.log(userType === "individual" ? data : cdata);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/verify-bvn`,
        userType === "individual" ? data : cdata,
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData.message === "success") {
        toast.success("BVN Verified", {
          position: toast.POSITION.TOP_CENTER,
        });
        setbvnVerified(true);
      }
    } catch (error) {
      setIsLoadBtn(false);
      setIsLoading(false);
      toast.error(error?.message || "BVN Validation Failed, Please Provide Correct Details", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [employmentDetail, setEmploymentDetails] = useState();
  const handleEmploymentDetail = async (obj) => {
    if (employmentDetail.employerName && employmentDetail.employerAddress && employmentDetail.occupation) {
      setIsLoadBtn(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/employment-detail/${customerEmail}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const formData = await response.data;
        if (formData) {
          setIsLoadBtn(false);
          setModal({ nokDetail: true });
          setEmploymentDetails(undefined);
        }
      } catch (error) {
        setIsLoadBtn(false);
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [nokDetail, setNokDetails] = useState();
  const handleNokDetail = async (obj) => {
    if (nokDetail.email && nokDetail.name && nokDetail.phone && nokDetail.nokAddress) {
      setIsLoadBtn(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/nok-detail/${customerEmail}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const formData = await response.data;
        if (formData) {
          setIsLoadBtn(false);
          setModal({ customerDocs: true });
          setNokDetails(undefined);
        }
      } catch (error) {
        setIsLoadBtn(false);
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled Correctly", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [customerDocuments, setCustomerDocuments] = useState();
  function encodeImage(element) {
    var file = element.target.files[0];
    var filename = file.name;
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const fileArr = res.split("base64,");
        let url = fileArr[1];
        setCustomerDocuments({
          ...customerDocuments,
          [element.target.name]: {
            encodedUpload: url,
            name: filename,
          },
        });
      }
    };
    reader.readAsDataURL(file);
  }
  const handleCustomerDocuments = async (obj) => {
    if (
      customerDocuments.idDocumentImage &&
      customerDocuments.idNumber &&
      customerDocuments.idTypeId &&
      customerDocuments.passportPhotographImage &&
      customerDocuments.utilityBillImage
    ) {
      setIsLoadBtn(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/my-document/${customerEmail}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const formData = await response.data;
        if (formData) {
          setIsLoadBtn(false);
          setModal({ bankDetails: true });
          setCustomerDocuments(undefined);
        }
      } catch (error) {
        setIsLoadBtn(false);
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [bankAccDetails, setBankAccDetails] = useState();

  const verifyBankAccount = async (action) => {
    console.log(details);
    const data = {
      accountNumber: bankAccDetails?.accountNumber,
      bankCode: bankAccDetails?.bankCode,
      verifyBusinessBankAccount: details?.type === "INDIVIDUAL" ? false : true,
    };
    const editData = {
      accountNumber: formData?.accountNumber,
      bankCode: formData?.bankCode,
      verifyBusinessBankAccount: details?.type === "INDIVIDUAL" ? false : true,
      userId: details?.id,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/individual-user/bank-account/verify`,
        action === "EDIT" ? editData : data,
        {
          headers: authHeader(),
        }
      );
      const responseData = await response.data.data;
      if (response.status === 200) {
        toast.success("Account Verified", {
          position: toast.POSITION.TOP_CENTER,
        });
        setFormData({ ...formData, accountName: "N/A for admins" });
        if (action === "EDIT") {
          setFormData({ ...formData, accountName: responseData.account_name });
        } else {
          setBankAccDetails({ ...bankAccDetails, accountName: responseData.account_name });
        }
      }
    } catch (error) {
      toast.error("Please Make Sure Your Bank Details Match", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const handleBankAccDetails = async (obj) => {
    if (bankAccDetails.accountName && bankAccDetails.accountNumber && bankAccDetails.bankCode) {
      setIsLoadBtn(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/bank-account/${customerEmail}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const formData = await response.data;
        if (formData) {
          setIsLoadBtn(false);
          setModal({ bankDetails: false });
          toast.success("Customer Details Added Successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          getCustomerDash();
          resetForm();
        }
      } catch (error) {
        setIsLoadBtn(false);
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [newCompanyUserDetail, setNewCompanyUserDetail] = useState();
  const addCompanyDash = async (obj) => {
    // setModal({ director: true });
    const data = {
      ...obj,
      source: "ROSABON_SALES",
      platform: "TREASURY",
      creationSource: "BACKEND",
    };
    if (
      companyFormData.address &&
      companyFormData.companyType &&
      companyFormData.contactPersonLastName &&
      companyFormData.contactPersonFirstName &&
      companyFormData.email &&
      companyFormData.regDate &&
      companyFormData.name &&
      companyFormData.natureOfBusiness &&
      companyFormData.rcNumber
    ) {
      setIsLoadBtn(true);
      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/company`, data, {
          headers: authHeader(),
        });
        const formData = await response.data;
        if (formData) {
          setIsLoadBtn(false);
          setNewCompanyUserDetail({
            email: companyFormData.email,
            type: companyFormData.companyType,
          });
          setModal({ director: true });
        }
      } catch (error) {
        const message = error.response.data.message;
        setIsLoadBtn(false);
        setIsLoading(false);
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      setIsLoadBtn(false);
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [directorDetail, setDirectorDetail] = useState();
  function encodeDirectorImage(element) {
    var file = element.target.files[0];
    var filename = file.name;
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const fileArr = res.split("base64,");
        let url = fileArr[1];
        setDirectorDetail({
          ...directorDetail,
          [element.target.name]: {
            encodedUpload: url,
            name: filename,
          },
        });
      }
    };
    reader.readAsDataURL(file);
  }
  const handleDirectorDetail = async (data) => {
    const obj = [data];
    // setModal({companyDoc: true});
    if (
      directorDetail.firstName &&
      directorDetail.lastName &&
      directorDetail.passportImage &&
      directorDetail.phone &&
      directorDetail.idTypeId &&
      directorDetail.idNumber &&
      directorDetail.idDocumentImage &&
      directorDetail.email &&
      directorDetail.bvn &&
      directorDetail.address
    ) {
      setIsLoadBtn(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/company/director-details/${newCompanyUserDetail.email}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const formData = await response.data;
        if (formData) {
          if (newCompanyUserDetail?.type === "DIR_ONLY") {
            setIsLoadBtn(false);
            setModal({ director: false });
            toast.success("New Director Added Successfully", {
              position: toast.POSITION.TOP_CENTER,
            });
            setDirectorDetail(undefined);
            setNewCompanyUserDetail(undefined);
          } else {
            setIsLoadBtn(false);
            setModal({ companyDoc: true });
            setDirectorDetail(undefined);
          }
        }
      } catch (error) {
        setIsLoadBtn(false);
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [companyDocument, setCompanyDocument] = useState();
  function encodeCompanyImage(element) {
    var file = element.target.files[0];
    var filename = file.name;
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const fileArr = res.split("base64,");
        let url = fileArr[1];
        setCompanyDocument({
          ...companyDocument,
          [element.target.name]: {
            encodedUpload: url,
            name: filename,
          },
        });
      }
    };
    reader.readAsDataURL(file);
  }

  // checking documents if the companyType is not Corporate Limited
  const checkDocs = async (obj) => {
    if (
      obj.certificateOfIncoImage &&
      obj.contactPersonIdNumber &&
      obj.contactPersonIdentityImage &&
      obj.contactPersonPhotographImage &&
      obj.idTypeId &&
      companyDocument.utilityBillImage
    ) {
      setIsLoadBtn(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/company/company-document/${newCompanyUserDetail.email}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const formData = await response.data;
        if (formData) {
          setModal({ companyDoc: false });
          setNewCompanyUserDetail(undefined);
          setCompanyDocument(undefined);
          toast.success("Customer added Successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          getCustomerDash();
          resetForm();
        }
      } catch (error) {
        setIsLoadBtn(false);
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setModal({ companyDoc: true });
        // resetForm();
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleCompanyDocument = (obj) => {
    if (newCompanyUserDetail.type === "CORPORATE_LIMITED") {
      if (obj.cacImage && obj.moaImage) {
        checkDocs(obj);
      } else {
        toast.error("CAC Document and Company MOA are compulsory for Corporate Limited Companies", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      checkDocs(obj);
    }
  };

  const onFormCancel = () => {
    setModal({});
    setCreateInvestmentFormData(createInvestmentInitialForm);
    setTouched(false);
    setFileErr(initFileErr);
    setCompanyEmail("");
    resetForm();
  };

  const onFormSubmit = () => {
    var dob = new Date(formData.dateOfBirth);
    var month_diff = Date.now() - dob.getTime();
    var age_dt = new Date(month_diff);
    var year = age_dt.getUTCFullYear();
    var age = Math.abs(year - 1970);

    if (bvnVerified === true) {
      if (
        formData.genderId &&
        formData.dateOfBirth &&
        formData.primaryPhoneNumber &&
        formData.nationality &&
        formData.accountOfficerId &&
        formData.stateId &&
        formData.countryId &&
        formData.city
      ) {
        if (age >= 18) {
          addCustomerDash(formData);
        } else {
          toast.error("You must be older than 18 to have an account", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        toast.error("Please Make Sure all Fields are Filled", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      // addCustomerDash(formData);
      toast.error("BVN Not Verified", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onEditClick = async (items) => {
    // console.log(items)
    if (items.type === "INDIVIDUAL") {
      getSingleCustomer(items);
      setModal({ edit: true });
    } else {
      getSingleCompany(items);
      setModal({ edit: true });
    }
  };

  const onEditPersonalInfo = async () => {
    setModal({ ...modal, editPersonalInfo: true });
    setFormData({
      secondaryPhoneNumber: details?.secondaryPhoneNumber,
      stateId: details?.state?.id,
      countryId: details?.countryOfResidence?.id,
      city: details?.city,
      houseNoAddress: details?.addressObject?.houseNoAddress,
      profilePicture: details?.profilePicture,
    });
    getStates(details?.countryOfResidence?.id);
    getLGAs(details?.state?.id);
  };

  const handleEditPersonalInfo = async (obj) => {
    const data = {
      ...obj,
      address: {
        houseNoAddress: obj.houseNoAddress,
        city: obj.city,
      },
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/personal-info/${details.email}`,
        data,
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({ editPersonalInfo: false });
        setFormData({});
        toast.success("Personal Info Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error.response;
      toast.error(err.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onEditEmploymentDetails = async () => {
    setModal({ ...modal, editEmploymentDetail: true });
    setFormData({
      employerAddress: details?.employmentDetail?.employerAddress,
      employerName: details?.employmentDetail?.employerName,
      occupation: details?.employmentDetail?.occupation,
    });
  };

  const handleEditEmploymentDetails = async (obj) => {
    if (formData.employerName && formData.employerAddress && formData.occupation) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/employment-detail/${details.email}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const result = await response.data;
        if (result) {
          setModal({ editEmploymentDetail: false });
          setFormData({});
          toast.success("Employement Detail Updated Successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          getCustomerDash(currentPage - 1);
        }
      } catch (error) {
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onEditNOKDetails = async () => {
    setModal({ ...modal, editNOKDetail: true });
    setFormData({
      name: details?.nokDetail?.name,
      email: details?.nokDetail?.email,
      phone: details?.nokDetail?.phone,
      address: details?.nokDetail?.address,
    });
  };

  const handleEditNokDetails = async (obj) => {
    if (formData.name && formData.email && formData.phone && formData.nokAddress) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/nok-detail/${details.email}`,
          obj,
          {
            headers: authHeader(),
          }
        );
        const result = await response.data;
        if (result) {
          setModal({ editNOKDetail: false });
          setFormData({});
          toast.success("NOK Detail Updated Successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          getCustomerDash(currentPage - 1);
          resetForm();
        }
      } catch (error) {
        const err = error.response;
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } else {
      toast.error("Please Make Sure all Fields are Filled", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onEditDocuments = async () => {
    setModal({ ...modal, editDocuments: true });
    setFormData({
      idNumber: details?.myDocument?.idNumber,
      idTypeId: details?.myDocument?.idType?.id,
    });
  };

  function encodeImageEdit(element) {
    var file = element.target.files[0];
    var filename = file.name;
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const fileArr = res.split("base64,");
        let url = fileArr[1];
        setFormData({
          ...formData,
          [element.target.name]: url,
        });
      }
    };
    reader.readAsDataURL(file);
  }

  const handleEditDocuments = async (obj) => {
    try {
      sethandleEditLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/my-document/${details.email}`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({ editDocuments: false });
        setFormData({});
        toast.success("Customer Documents Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error.response;
      toast.error(err.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      sethandleEditLoading(false);
    }
  };

  const onEditBank = async () => {
    getBankDetails(details);
    setFormData({
      accountName: userBankDetails?.accountName,
      accountNumber: userBankDetails?.accountNumber,
      bankCode: userBankDetails?.bank?.code,
    });
    setModal({ ...modal, editBank: true });
  };

  const handleEditBankAccDetails = async (obj) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/bank-account/${details.email}`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({ editBank: false });
        setFormData({});
        toast.success("Bank Details Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error.response;
      toast.error(err.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const [userBankDetails, setUserBankDetails] = useState();
  const getBankDetails = async (item) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/individual-user/bank-account/${item.email}`,
        {
          headers: authHeader(),
        }
      );
      const resultData = await response.data;
      if (resultData) {
        setUserBankDetails(resultData);
      }
      return { formData };
    } catch (error) {}
  };

  const onUpdateAccOfficer = async () => {
    getAccOfficers();
    // console.log(details);
    let usersId = details?.type === "INDIVIDUAL" ? details?.id : details?.useraccount?.id;
    let accountOfficersId = details?.type === "INDIVIDUAL" ? details?.accountOfficer?.id : details?.accountOfficerId;
    setFormData({
      userId: usersId,
      accountOfficerId: accountOfficersId,
    });
    setModal({ ...modal, updateAccOfficer: true });
  };

  const handleUpdateAccOfficer = async (obj) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/update-account-officer`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({ updateAccOfficer: false });
        setFormData({});
        toast.success("Account Officer Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error.response;
      toast.error(err.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onMakeAccountOfficer = () => {
    setCompanyEmail("");
    setModal({ ...modal, makeAccountOfficer: true });
  };

  const handleMakeAccountOfficer = async () => {
    const accountOfficerUserId = details?.type === "INDIVIDUAL" ? details?.id : details?.useraccount?.id;
    try {
      setIsAoLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v3/users/set-to-account-officer`,
        { accountOfficerCompanyEmail: companyEmail, accountOfficerUserId },
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({ makeAccountOfficer: false });
        setCompanyEmail("");
        toast.success(result.message || "User set as account officer successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error?.response;
      toast.error(err?.data?.message || "Unable to set user as account officer", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setIsAoLoading(false);
    }
  };

  const [accOfficers, setAccOfficers] = useState();
  const getAccOfficers = async (item) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/fetch-account-officers`,
        {
          headers: authHeader(),
        }
      );
      const resultData = await response.data.data;
      if (resultData) {
        // console.log(resultData);
        setAccOfficers(resultData);
      }
      return { formData };
    } catch (error) {}
  };

  const onEditCompanyInfo = async () => {
    setModal({ ...modal, editCompanyInfo: true });
    setFormData({
      natureOfBusiness: details?.natureOfBusiness,
      companyType: details?.companyType,
      address: details?.companyAddress,
      contactPersonFirstName: details?.contactFirstName,
      contactPersonLastName: details?.contactLastName,
      contactPersonEmail: details?.contactPersonEmail,
      contactPersonPhoneNo: details?.contactPersonPhoneNo,
    });
  };

  const handleEditCompanyInfo = async (obj) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/company/${details.useraccount?.email}`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({});
        setFormData({});
        toast.success("Company Info Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error.response;
      toast.error(err.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  function encodeEditDirImage(element) {
    var file = element.target.files[0];
    var filename = file.name;
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const fileArr = res.split("base64,");
        let url = fileArr[1];
        setFormData({
          ...formData,
          [element.target.name]: url,
        });
      }
    };
    reader.readAsDataURL(file);
  }

  const handleEditDirector = async (obj) => {
    const data = [obj];
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/company/director-details/${details?.useraccount?.email}`,
        data,
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({ editDocuments: false });
        setFormData({});
        toast.success("Director Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error.response;
      toast.error(err.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onEditCompanyDocs = async () => {
    setModal({ ...modal, editCompanyDocs: true });
    setFormData({
      cacImage: details?.companyDocument?.cacImage?.imageUrl,
      certificateOfIncoImage: details?.companyDocument?.certificateOfIncoImage?.imageUrl,
      contactPersonIdentityImage: details?.companyDocument?.contactPersonIdImage?.imageUrl,
      contactPersonPhotographImage: details?.companyDocument?.contactPersonPhotographImage?.imageUrl,
      moaImage: details?.companyDocument?.moaImage?.imageUrl,
      utilityBillImage: details?.companyDocument?.utilityBillImage?.imageUrl,
    });
    setCompanyDocument({
      idTypeId: details?.companyDocument?.idType?.id,
      contactPersonIdNumber: details?.companyDocument?.idNumber,
    });
  };

  function encodeEditCompanyImage(element) {
    var file = element.target.files[0];
    var filename = file.name;
    var reader = new FileReader();
    reader.onloadend = function () {
      const res = reader.result;
      if (res) {
        const fileArr = res.split("base64,");
        let url = fileArr[1];
        setCompanyDocument({
          ...companyDocument,
          [element.target.name]: url,
        });
      }
    };
    reader.readAsDataURL(file);
  }

  const handleEditCompanyDocument = async (obj) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/admin/customer-databoard/company/company-document/${details.useraccount?.email}`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const result = await response.data;
      if (result) {
        setModal({});
        setFormData({});
        toast.success("Documents Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        getCustomerDash(currentPage - 1);
      }
    } catch (error) {
      const err = error.response;
      toast.error(err.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onViewClick = (items) => {
    setModal({ view: true });
    if (items.type === "INDIVIDUAL") {
      getSingleCustomer(items);
    } else {
      getSingleCompany(items);
    }
  };

  const openReactivateModal = () => {
    setReactivateReason("");
    setModal((prev) => ({ ...prev, reactivate: true }));
  };

  const closeReactivateModal = () => {
    setModal((prev) => ({ ...prev, reactivate: false }));
    setReactivateReason("");
  };

  const handleReactivateAccount = async () => {
    const email = details?.email || details?.useraccount?.email;
    try {
      setIsReactivateLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/users/reactivate-account`,
        { email },
        {
          headers: authHeader(),
        }
      );
      if (response.data) {
        closeReactivateModal();
        if (details?.type === "INDIVIDUAL") {
          getSingleCustomer(details);
        } else {
          getSingleCompany(details);
        }
        getCustomerDash(currentPage - 1);
        toast.success("Account successfully reactivated.", { position: toast.POSITION.TOP_CENTER });
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "Unable to reactivate account.";
      toast.error(errorMsg, { position: toast.POSITION.TOP_CENTER });
    } finally {
      setIsReactivateLoading(false);
    }
  };

  const onInvestmentClick = (item) => {
    setSelectedCustomer(item);
    setModal({ investment: true });
  };

  //function to accurately round amount
  function roundHalfToEven(num, decimal) {
    var p = Math.pow(10, decimal);
    var n = Math.round(num * p);
    var dif = n - num * p;
    var rounded = dif == -0.5 ? (n % 2 == 0 ? n : n + 1) : n;
    return rounded / p;
  }

  // const indexOfLastItem = currentPage * itemPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemPerPage;
  // const currentItems = customerDashboard?.slice(indexOfFirstItem, indexOfLastItem);

  const { errors, register, handleSubmit } = useForm();

  const getAllProducts = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproduct`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setProducts(resultData?.filter(({ status }) => status === "ACTIVE"));
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getWithholdingTax = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trwithholding-tax`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        const withdrawTax = resultData[0]?.rate;
        setWithholding_tax(withdrawTax);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getSingleProductById = async (id) => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproduct/${id}`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      toast.info("got it")
      const resultData = data.body;
      console.log(resultData)
      if (resultData) {
        setSingleProduct(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllExchangeRates = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trexchange-rates`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setExchangeRates(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const [investmentRates, setInvestmentRates] = useState();
  const getAllInvestmentRates = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trinvestment-rates`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setInvestmentRates(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const createInvestment = async (payload) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/trcreate-plan/${selectedCustomer?.email}`,
        payload,
        {
          headers: authHeader(),
        }
      );
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setInvestMsg(resultData);
        toast.success("Investment Created Successfully");
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to create investment");
      setInvestMsg(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (createInvestmentFormData.product) {
      getSingleProductById(createInvestmentFormData?.product);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createInvestmentFormData.product]);

  const recentDate = moment(date).format("YYYY-MM-DD");

  useEffect(() => {
    getCustomerDash();
    getBanks();
    getGender();
    getCountries();
    getaccountOfficers();
    getIDType();
    getAllProducts();
    getWithholdingTax();
    getAllExchangeRates();
    getAllInvestmentRates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [investmentSummary, setInvestmentSummary] = useState({
    planName: "",
    startDate: "",
    endDate: "",
    principal: 0.0,
    interestRate: 0,
    interestReceiptOption: "",
    calculatedInterest: 0.0,
    withholdingTax: 0,
    paymentMaturity: 0.0,
  });

  // calculate minimum and maximum tenor
  let minTenor = { tenorDays: Infinity };
  let maxTenor = { tenorDays: 0 };
  if (singleProduct?.tenors) {
    if (singleProduct.tenors?.length > 1) {
      singleProduct.tenors?.forEach((item) => (item.tenorDays < minTenor.tenorDays ? (minTenor = item) : null));
      singleProduct.tenors?.forEach((item) => (item.tenorDays > maxTenor.tenorDays ? (maxTenor = item) : null));
    } else {
      minTenor = singleProduct?.tenors[0]?.tenorDays;
      maxTenor = singleProduct?.tenors[0]?.tenorDays;
    }
    minTenor = moment(recentDate).add(minTenor?.tenorDays, "days")?._d;
    maxTenor = moment(recentDate).add(maxTenor?.tenorDays, "days")?._d;
  }

  // const computeTenorDays = useCallback(() => {
  //   if (checkAtMaturity) {
  //     const customTenorDays = moment(createInvestmentFormData.actualMaturityDate).diff(recentDate, "days");

  //     const selectedTenor = singleProduct?.tenors?.filter((item) => customTenorDays < item.tenorDays);

  //     function findMinValue(arr) {
  //       if (arr?.length) {
  //         let min = Infinity;

  //         for (let obj of arr) {
  //           min = obj?.tenorDays < min ? obj?.tenorDays : min;
  //         }

  //         return min;
  //       }
  //     }

  //     return findMinValue(selectedTenor);
  //   } else {
  //     return singleProduct?.tenors?.find((item) => item.id === parseInt(formData.tenor))?.tenorDays;
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [createInvestmentFormData.actualMaturityDate, createInvestmentFormData.tenor]);

  const paymentAtMaturity = (intRecOption, principal, withholdingTax, tenorMonths, calculatedInterest) => {
    let result = 0;
    const interestMonthly = calculatedInterest / tenorMonths;
    const interestQuaterly = calculatedInterest / (tenorMonths / 4);
    const interestBiAnnual = calculatedInterest / (tenorMonths / 6);
    switch (intRecOption) {
      case "MATURITY":
      case "BACKEND_MATURITY":
        result =
          Math.round(
            (principal + calculatedInterest - calculatedInterest * (withholdingTax / 100)) * 100 + Number.EPSILON
          ) / 100;
        break;

      case "UPFRONT":
      case "BACKEND_UPFRONT":
        result = Math.round(principal * 100 + Number.EPSILON) / 100;
        break;

      case "MONTHLY":
      case "BACKEND_MONTHLY":
        if (tenorMonths < 1) {
          result = null;
        } else {
          result =
            Math.round(
              (principal + interestMonthly - (withholdingTax / 100) * interestMonthly) * 100 + Number.EPSILON
            ) / 100;
        }
        break;

      case "QUARTERLY":
      case "BACKEND_QUARTERLY":
        if (tenorMonths < 4) {
          result = null;
        } else {
          result =
            Math.round(
              (principal + interestQuaterly - (withholdingTax / 100) * interestQuaterly) * 100 + Number.EPSILON
            ) / 100;
        }
        break;

      case "BI_ANNUAL":
      case "BACKEND_BI_ANNUAL":
        if (tenorMonths < 6) {
          result = null;
        } else {
          result =
            Math.round(
              (principal + interestBiAnnual - (withholdingTax / 100) * interestBiAnnual) * 100 + Number.EPSILON
            ) / 100;
        }
        break;

      default:
        break;
    }
    return result;
  };

  const handleInvestmentInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "targetAmount" || name === "contributionValue") {
      setCreateInvestmentFormData((prev) => ({ ...prev, [name]: Number(parseFloat(value).toFixed(2)) }));
      setConValue(e.target.name);
    } else if (name === "interestRate") {
      setCreateInvestmentFormData((prev) => ({ ...prev, [name]: Number(parseFloat(value).toFixed(2)) }));
    } else {
      setCreateInvestmentFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleInvestmentSelectChange = (e, name) => {
    if (name === "autoRenew") {
      setCreateInvestmentFormData((prev) => ({
        ...prev,
        [name]: e.value,
        autoRollOver: e.value,
      }));
    } else {
      setCreateInvestmentFormData((prev) => ({ ...prev, [name]: e.value }));
    }
  };
  const handleInvestmentCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCreateInvestmentFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    getCustomerDash(pageNumber - 1);
  };

  useEffect(() => {
    setCreateInvestmentFormData((prev) => ({
      ...prev,
      customerName: `${selectedCustomer?.firstName} ${selectedCustomer?.lastName}`,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const convertReadableTextForInterestOptions = useCallback((value) => {
    let label;
    switch (value) {
      case "hasUpfrontInterestRate":
        label = "UPFRONT";
        break;

      case "hasMonthlyInterestRate":
        label = "MONTHLY";
        break;

      case "hasQuarterlyInterestRate":
        label = "QUARTERLY";
        break;

      case "hasBiAnnualInterestRate":
        label = "BI_ANNUAL";
        break;

      case "hasMaturityRate":
        label = "MATURITY";
        break;

      case "hasBackendUpfrontInterestRate":
        label = "BACKEND_UPFRONT";
        break;

      case "hasBackendMonthlyInterestRate":
        label = "BACKEND_MONTHLY";
        break;

      case "hasBackendQuarterlyInterestRate":
        label = "BACKEND_QUARTERLY";
        break;

      case "hasBackendBiAnnualInterestRate":
        label = "BACKEND_BI_ANNUAL";
        break;

      case "hasBackendMaturityRate":
        label = "BACKEND_MATURITY";
        break;
      default:
        break;
    }
    return label;
  }, []);

  const productOptions =
    products?.map((prod) => ({
      label: prod.productName,
      value: prod.id,
    })) ?? [];

  const currencyOptions =
    singleProduct?.currency
      ?.filter((curr) => curr?.status === "ACTIVE")
      ?.map((curr) => ({
        label: curr.name,
        value: curr.id,
      })) ?? [];

  const tenorOptionsPrev =
    singleProduct?.tenors
      ?.filter(({ tenorStatus }) => tenorStatus === "ACTIVE")
      ?.map((ten) => ({
        label: ten.tenorName,
        value: ten.id,
      })) ?? [];

  const tenorOptions = singleProduct?.allowCustomization
    ? [...tenorOptionsPrev, { label: "Customize Tenor", value: 0 }]
    : tenorOptionsPrev;

  const savingFrequencyOptions = [
    { label: "Daily", value: "DAILY" },
    { label: "Weekly", value: "WEEKLY" },
    { label: "Monthly", value: "MONTHLY" },
  ];

  const monthsOptions = [...Array(28).keys()].map((val) => ({
    label: val + 1,
    value: val + 1,
  }));

  const weeksOptions = [
    { label: "MONDAY", value: "MONDAY" },
    { label: "TUESDAY", value: "TUESDAY" },
    { label: "WEDNESDAY", value: "WEDNESDAY" },
    { label: "THURSAY", value: "THURSAY" },
    { label: "FRIDAY", value: "FRIDAY" },
    { label: "SATURDAY", value: "SATURDAY" },
    { label: "SUNDAY", value: "SUNDAY" },
  ];

  const updateNumOfTickets = (value) => {
    let ticketNo;
    if (singleProduct?.properties?.allowsMonthlyDraw) {
      if (value === null) {
        return null;
      } else {
        ticketNo = value / singleProduct?.minTransactionLimit;
        return Math.floor(ticketNo);
      }
    } else {
      return 0;
    }
  };

  useEffect(() => {
    let selectedTenor = singleProduct?.tenors?.find((item) => item.id === parseInt(createInvestmentFormData.tenor));
    let endDate = moment(recentDate).add(selectedTenor?.tenorDays, "days")?._d;
    // calculate principal

    const customTenorDays = moment(createInvestmentFormData.actualMaturityDate).diff(recentDate, "days");

    const calculateSI = (principal, rate, time) => {
      const SI = (principal * rate * (time / 365)) / 100;
      return Math.round(SI * 100 + Number.EPSILON) / 100;
    };

    // }
    setInvestmentSummary({
      ...investmentSummary,
      planName: createInvestmentFormData?.planName,
      startDate: createInvestmentFormData.dateCreated,
      endDate: checkAtMaturity
        ? moment(createInvestmentFormData.actualMaturityDate).format("YYYY-MM-DD")
        : moment(endDate).format("YYYY-MM-DD"),
      interestRate: createInvestmentFormData.interestRate,
      principal: singleProduct?.properties?.hasTargetAmount
        ? createInvestmentFormData.targetAmount
        : Number(createInvestmentFormData.amount),
      withholdingTax: withholding_tax,
      // interestPaymentFrequency: createInvestmentFormData.interestReceiptOption,
      interestReceiptOption: createInvestmentFormData.interestReceiptOption,
      calculatedInterest: calculateSI(
        singleProduct?.properties?.hasTargetAmount
          ? createInvestmentFormData.targetAmount
          : Number(createInvestmentFormData.amount),
        createInvestmentFormData.interestRate,
        checkAtMaturity ? customTenorDays : selectedTenor?.tenorDays
      ),
      paymentMaturity: paymentAtMaturity(
        createInvestmentFormData.interestReceiptOption,
        singleProduct?.properties?.hasTargetAmount
          ? createInvestmentFormData.targetAmount
          : Number(createInvestmentFormData.amount),
        withholding_tax,
        checkAtMaturity
          ? Math.floor(moment(createInvestmentFormData.actualMaturityDate).diff(recentDate, "days") / 30)
          : Math.floor(selectedTenor?.tenorDays / 30),
        calculateSI(
          singleProduct?.properties?.hasTargetAmount
            ? createInvestmentFormData.targetAmount
            : Number(createInvestmentFormData.amount),
          createInvestmentFormData.interestRate,
          createInvestmentFormData.tenor === 0 ? customTenorDays : selectedTenor?.tenorDays
        )
      ),
    });

    setCreateInvestmentFormData({
      ...createInvestmentFormData,
      actualMaturityDate:
        createInvestmentFormData.tenor === 0
          ? moment(createInvestmentFormData.actualMaturityDate).format("YYYY-MM-DD")
          : moment(endDate).format("YYYY-MM-DD"),
      numberOfTickets: updateNumOfTickets(
        singleProduct?.properties?.hasTargetAmount
          ? createInvestmentFormData.targetAmount
          : Number(createInvestmentFormData.amount)
      ),
      planSummary: investmentSummary,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    createInvestmentFormData.planName,
    createInvestmentFormData.savingFrequency,
    createInvestmentFormData.tenor,
    createInvestmentFormData.interestRate,
    createInvestmentFormData.interestReceiptOption,
    createInvestmentFormData.targetAmount,
    createInvestmentFormData.amount,
    createInvestmentFormData.actualMaturityDate,
    investmentSummary.calculatedInterest,
    computeInvestment,
  ]);

  const handleCreateInvestment = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/trcreate-plan/${selectedCustomer?.email}`, obj, {
        "Content-Type": "application/json",
        Accept: "application/json",
      });
      // const formData = await response.data;
    } catch (error) {
      // setLoading(false);
    }
  };

  // const mergeObjects = (arr = []) => {
  //   const res = {};
  //   arr?.forEach((obj) => {
  //     if (obj) {
  //       for (key in obj) {
  //         if (key) {
  //           res[key] = obj[key];
  //         }
  //       }
  //     }
  //   });
  //   return res;
  // };

  // const defineInterestOptions = Object.keys(singleProduct?.properties?.interestOptions || {})
  //   .map(function (key) {
  //     return { [key]: singleProduct?.properties?.interestOptions[key] };
  //   })
  //   .filter((option) => Object.values(option).every((value) => value === true));

  // const interestOptionsObject = mergeObjects(defineInterestOptions);

  // const interestReceiptOptions = Object.keys(interestOptionsObject || {}).map((key) => ({
  //   label: convertReadableTextForInterestOptions(key)?.toLowerCase(),
  //   value: convertReadableTextForInterestOptions(key),
  // }));

  // function to compute target amount and computed value
  const contribValue = () => {
    const selectedTenor = singleProduct?.tenors?.find((item) => item.id === parseInt(createInvestmentFormData.tenor));

    const customTenorDays = moment(createInvestmentFormData.actualMaturityDate).diff(recentDate, "days");

    if (singleProduct?.properties?.hasTargetAmount) {
      if (createInvestmentFormData.savingFrequency !== "") {
        if (conValue === "targetAmount") {
          let computedValue = null;
          switch (createInvestmentFormData.savingFrequency) {
            case "DAILY":
              computedValue =
                createInvestmentFormData.targetAmount / (checkAtMaturity ? customTenorDays : selectedTenor?.tenorDays);
              setValidSavingsFreq(true);
              break;

            case "WEEKLY":
              if (customTenorDays < 7 || selectedTenor?.tenorDays < 7) {
                computedValue = null;
                setValidSavingsFreq(false);
              } else {
                if (checkAtMaturity) {
                  computedValue = createInvestmentFormData.targetAmount / Math.floor(customTenorDays / 7);
                } else {
                  computedValue = createInvestmentFormData.targetAmount / Math.floor(selectedTenor?.tenorDays / 7);
                }
              }
              break;

            case "MONTHLY":
              if (customTenorDays < 30 || selectedTenor?.tenorDays < 30) {
                computedValue = null;
                setValidSavingsFreq(false);
              } else {
                if (checkAtMaturity) {
                  computedValue = createInvestmentFormData.targetAmount / Math.floor(customTenorDays / 30);
                } else {
                  computedValue = createInvestmentFormData.targetAmount / Math.floor(selectedTenor?.tenorDays / 30);
                }
              }
              break;

            default:
              break;
          }
          setCreateInvestmentFormData({
            ...createInvestmentFormData,
            contributionValue: roundHalfToEven(computedValue, 2),
          });
        } else {
          if (singleProduct?.properties?.hasTargetAmount) {
            let computedValue;
            switch (createInvestmentFormData.savingFrequency) {
              case "DAILY":
                computedValue =
                  createInvestmentFormData.contributionValue *
                  (checkAtMaturity ? customTenorDays : selectedTenor?.tenorDays);
                setValidSavingsFreq(true);
                break;

              case "WEEKLY":
                if (customTenorDays < 7 || selectedTenor?.tenorDays < 7) {
                  computedValue = undefined;
                  setValidSavingsFreq(false);
                } else {
                  if (checkAtMaturity) {
                    computedValue = createInvestmentFormData.contributionValue * Math.floor(customTenorDays / 7);
                  } else {
                    computedValue =
                      createInvestmentFormData.contributionValue * Math.floor(selectedTenor?.tenorDays / 7);
                  }
                }

                break;

              case "MONTHLY":
                if (customTenorDays < 30 || selectedTenor?.tenorDays < 30) {
                  computedValue = undefined;
                  setValidSavingsFreq(false);
                } else {
                  if (checkAtMaturity) {
                    computedValue = createInvestmentFormData.contributionValue * Math.floor(customTenorDays / 30);
                  } else {
                    computedValue =
                      createInvestmentFormData.contributionValue * Math.floor(selectedTenor?.tenorDays / 30);
                  }
                }
                break;

              default:
                break;
            }
            setCreateInvestmentFormData({
              ...createInvestmentFormData,
              targetAmount: roundHalfToEven(computedValue, 2),
            });
          }
        }
      }
    }
  };

  const calcContribValue = useMemo(
    () => contribValue(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      createInvestmentFormData.savingFrequency,
      createInvestmentFormData.tenor,
      createInvestmentFormData.targetAmount,
      createInvestmentFormData.contributionValue,
      createInvestmentFormData.actualMaturityDate,
    ]
  );

  // function to get investment rate
  const fetchIntRate = (intRecOption) => {
    let interestRate;
    let principal = singleProduct?.properties?.hasTargetAmount
      ? createInvestmentFormData.targetAmount
      : Number(createInvestmentFormData.amount);

    const customTenorDays = moment(createInvestmentFormData.actualMaturityDate).diff(recentDate, "days");

    const selectedTenor = singleProduct.tenors?.find((item) => item.id === parseInt(createInvestmentFormData.tenor));

    const maxTenorDays = () => {
      if (checkAtMaturity) {
        return customTenorDays;
      } else {
        return selectedTenor?.tenorDays;
      }
    };
    const invRateCurrency = investmentRates
      ?.filter((data) => data?.product?.id === parseInt(singleProduct?.id))
      ?.find((item) => item?.currency?.id === createInvestmentFormData.currency)?.currency?.name;
    const curr_name = singleProduct?.currency?.find((item) => item.id === createInvestmentFormData.currency);
    const currency = exchangeRates?.find((item) => item.name === curr_name?.name);

    const convPrincipal = () => {
      let convertPrincipal;
      if (invRateCurrency === currency?.name) {
        convertPrincipal = principal;
      }
      return convertPrincipal;
    };

    let rate = investmentRates?.find((item) => {
      return (
        item.product.id === parseInt(singleProduct?.id) &&
        item.currency.id === createInvestmentFormData.currency &&
        convPrincipal() >= item.minimumAmount &&
        convPrincipal() <= item.maximumAmount &&
        maxTenorDays() >= item.minimumTenor &&
        maxTenorDays() <= item.maximumTenor
      );
    });
    let directDebitRate = rate?.percentDirectDebit ? rate?.percentDirectDebit : 0;
    if (rate !== undefined) {
      switch (intRecOption) {
        case "MONTHLY":
          interestRate = rate?.monthlyInterestRate;
          break;

        case "UPFRONT":
          interestRate = rate?.upfrontInterestRate;
          break;

        case "QUARTERLY":
          interestRate = rate?.quarterlyInterestRate;
          break;

        case "BI_ANNUAL":
          interestRate = rate?.biAnnualInterestRate;
          break;

        case "MATURITY":
          interestRate = rate?.maturityRate;
          break;

        case "BACKEND_UPFRONT":
          interestRate = rate?.backendUpfrontInterestRate;
          break;

        case "BACKEND_BI_ANNUAL":
          interestRate = rate?.backendBiAnnualInterestRate;
          break;

        case "BACKEND_MONTHLY":
          interestRate = rate?.backendMonthlyInterestRate;
          break;

        case "BACKEND_MATURITY":
          interestRate = rate?.backendMaturityRate;
          break;

        case "BACKEND_QUARTERLY":
          interestRate = rate?.backendQuarterlyInterestRate;
          break;

        default:
          interestRate = null;
          break;
      }
      if (interestRate === null) {
        interestRate =
          createInvestmentFormData.directDebit === true || createInvestmentFormData.directDebit === "true"
            ? 0 + directDebitRate
            : null;
        // interestRate = formData.directDebit ? 0 : 0;
        return interestRate;
      } else {
        interestRate =
          createInvestmentFormData.directDebit === true || createInvestmentFormData.directDebit === "true"
            ? interestRate + directDebitRate
            : interestRate;
        return interestRate;
      }
    } else {
      interestRate = undefined;
      return interestRate;
    }
  };

  useEffect(
    () => {
      let curr = singleProduct?.currency?.find((item) => item.id === createInvestmentFormData?.currency);
      const selectedCurrency = exchangeRates?.filter((item) => item.name === curr?.name)[0];
      const singleCat = products?.find((item) => item?.id === createInvestmentFormData?.product)?.productCategory?.id;
      if (!createInvestmentFormData.requestConcession) {
        setCreateInvestmentFormData({
          ...createInvestmentFormData,
          interestRate: fetchIntRate(createInvestmentFormData.interestReceiptOption),
          productCategory: singleCat,
          exchangeRate:
            createInvestmentFormData.currency === 8
              ? 1
              : createInvestmentFormData.currency === ""
              ? 1
              : Number(parseFloat(selectedCurrency?.buyingPrice).toFixed(2)),
        });
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      createInvestmentFormData.interestReceiptOption,
      createInvestmentFormData.tenor,
      createInvestmentFormData.directDebit,
      createInvestmentFormData.product,
      createInvestmentFormData.currency,
      createInvestmentFormData.requestConcession,
    ]
  );

  const handleInvestmentFileChange = (e, name) => {
    const { files } = e.target;

    if (!fileErr[name]) {
      setFileErr({
        [name]: true,
      });
    }

    const encodedFileBase64 = (file) => {
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          const res = reader.result;
          if (res) {
            setCreateInvestmentFormData({
              ...createInvestmentFormData,
              [name]: res.split("base64,")[1],
            });
          }
        };
        reader.onerror = (error) => {};
      }
    };

    if (
      files[0]?.size <= 2000000 &&
      (files[0]?.type === "image/jpeg" || files[0]?.type === "application/pdf" || files[0]?.type === "image/png")
    ) {
      encodedFileBase64(files[0]);
    } else {
      setCreateInvestmentFormData({
        ...createInvestmentFormData,
        [name]: "",
      });
    }
  };

  const createInvestmentSubmit = (e) => {
    e.preventDefault();
    const submitCreateInvestment = {
      ...createInvestmentFormData,
      tenor: createInvestmentFormData?.tenor === 0 ? null : createInvestmentFormData?.tenor,
    };
    createInvestment(submitCreateInvestment);
    setModal({ investment: false });
    setCreateInvestmentFormData(createInvestmentInitialForm);
    setComputeInvestment(false);
    setFileErr(initFileErr);
    setTouched(false);
  };

  // validate investment submit
  const validateCreateInvestment = () => {
    if (
      createInvestmentFormData.planName !== "" &&
      createInvestmentFormData.currency !== "" &&
      createInvestmentFormData.product !== "" &&
      createInvestmentFormData.tenor !== "" &&
      createInvestmentFormData.paymentProofImage !== "" &&
      ((createInvestmentFormData.targetAmount >= singleProduct?.minTransactionLimit &&
        createInvestmentFormData.targetAmount <= singleProduct?.maxTransactionLimit &&
        singleProduct?.properties?.hasTargetAmount) ||
        (createInvestmentFormData.amount >= singleProduct?.minTransactionLimit &&
          createInvestmentFormData.amount <= singleProduct?.maxTransactionLimit &&
          !singleProduct?.properties?.hasTargetAmount)) &&
      createInvestmentFormData.interestReceiptOption !== "" &&
      createInvestmentFormData.investmentValueDate !== "" &&
      (createInvestmentFormData.requestConcession
        ? createInvestmentFormData.approvalConcessionDocumentImage !== ""
        : true) &&
      (createInvestmentFormData.requestConcession
        ? createInvestmentFormData.interestRate >= fetchIntRate(createInvestmentFormData.interestReceiptOption)
        : true) &&
      (!createInvestmentFormData.requestConcession
        ? createInvestmentFormData.interestRate <= fetchIntRate(createInvestmentFormData.interestReceiptOption)
        : true)
    ) {
      return true;
    } else return false;
  };

  const [officerIndex, setOfficerIndex] = useState();
  const setOfficer = (id) => {
    let index = accountOfficers.findIndex((officer) => officer?.useraccount?.id === parseInt(id));
    setOfficerIndex(index.toString());
  };

  // function to filter interest receipt option based on number of tenor days
  const filterIntRecOpt = (numOfDays) => {
    if (numOfDays < 30) {
      return ["hasBackendUpfrontInterestRate", "hasBackendMaturityRate"];
    } else if (numOfDays >= 30 && numOfDays < 90) {
      return ["hasBackendUpfrontInterestRate", "hasBackendMaturityRate", "hasBackendMonthlyInterestRate"];
    } else if (numOfDays >= 90 && numOfDays < 730) {
      return [
        "hasBackendUpfrontInterestRate",
        "hasBackendMaturityRate",
        "hasBackendMonthlyInterestRate",
        "hasBackendQuarterlyInterestRate",
      ];
    } else if (numOfDays >= 730) {
      return [
        "hasBackendUpfrontInterestRate",
        "hasBackendMaturityRate",
        "hasBackendMonthlyInterestRate",
        "hasBackendQuarterlyInterestRate",
        "hasBackendBiAnnualInterestRate",
      ];
    }
  };

  return (
    <React.Fragment>
      {calcContribValue}
      <Head title="Customer Databoard"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Customer Management</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Customer..."
                    />
                  </div>
                  <Button
                    color="primary"
                    outline
                    className="mr-2"
                    onClick={() => setVerifyBvnModal(true)}
                  >
                    <Icon name="shield-check" className="mr-1"></Icon>
                    <span>Verify User BVN</span>
                  </Button>
                  <AllowAccess allowedRights={["CREATE_CUSTOMER"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus"></Icon>
                      <span>Add New Customer</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading && customerDashboard.length === 0 ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <CustomerDashboardTable
                customerDashboard={customerDashboard}
                modal={modal}
                handleView={onViewClick}
                onEditClick={onEditClick}
                handleInvestment={onInvestmentClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {customerDashboard && customerDashboard.length > 0 ? (
              <PaginationComponent
                itemPerPage={10}
                totalItems={totalPages}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Customer Found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Customer</h5>
              <div className="mt-4">
                <Tabs defaultActiveKey="1" centered type="card" size="large">
                  <Tabs.TabPane tab="Individual" key="1">
                    <Form className="row gy-4" onSubmit={handleSubmit()}>
                      {/* <Col md="6">
                        <FormGroup>
                          <label className="form-label">Profile Picture</label>
                          <input
                            type="file"
                            name="profilePicture"
                            accept="image/*"
                            className="form-control"
                            onChange={(e) => encodeProfilePic(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                          />

                          {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                        </FormGroup>
                      </Col> */}
                      <Col md="12">
                        <div>
                          <h5 className="title">Personal Information</h5>
                        </div>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">First Name</label>
                          <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            onChange={(e) => onInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Middle Name</label>
                          <input
                            type="text"
                            name="middleName"
                            placeholder="Middle Name"
                            onChange={(e) => onInputChange(e)}
                            className="form-control"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Last Name</label>
                          <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            onChange={(e) => onInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Gender</label>
                          <select
                            className="form-control"
                            name="gender"
                            onChange={(e) => setFormData({ ...formData, genderId: parseInt(e.target.value) })}
                            ref={register({
                              required: "This field is required",
                            })}
                          >
                            <option>Select Gender</option>
                            {genders ? (
                              <>
                                {genders.map((gender) => (
                                  <option value={gender.id}>{gender.gender}</option>
                                ))}
                              </>
                            ) : null}
                          </select>
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">DOB</label>
                          <div>
                            <DatePicker
                              format={dateFormat}
                              onChange={(date, dateString) => setFormData({ ...formData, dateOfBirth: dateString })}
                              style={{ width: "20rem" }}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Primary Phone Number</label>
                          <PhoneInput
                            name="primaryPhoneNumber"
                            placeholder="Phone Number"
                            country={"ng"}
                            onChange={(phone) => {
                              if (phone.length > 13) {
                                toast.error("Input shouldn't exceed 10 characters", {
                                  position: toast.POSITION.TOP_CENTER,
                                });
                              } else {
                                setFormData({ ...formData, primaryPhoneNumber: phone.replace("234", "0") });
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Secondary Phone Number</label>
                          <PhoneInput
                            name="secondaryPhoneNumber"
                            placeholder="Secondary Phone Number"
                            country={"ng"}
                            onChange={(phone) => {
                              if (phone.length > 13) {
                                toast.error("Input shouldn't exceed 10 characters", {
                                  position: toast.POSITION.TOP_CENTER,
                                });
                              } else {
                                setFormData({ ...formData, secondaryPhoneNumber: phone.replace("234", "0") });
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Email</label>
                          <input
                            type="text"
                            name="email"
                            placeholder="Email Address"
                            onChange={(e) => onInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <div className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                          <FormGroup>
                            <label className="form-label">BVN</label>
                            <input
                              type="text"
                              name="bvn"
                              placeholder="BVN"
                              onChange={(e) => onInputChange(e)}
                              className="form-control"
                              ref={register({
                                required: "This field is required",
                              })}
                            />
                            {errors.name && <span className="invalid">{errors.name.message}</span>}
                          </FormGroup>
                          <div>
                            <Button
                              color="primary"
                              size="md"
                              disabled={bvnVerified}
                              onClick={(e) => {
                                e.preventDefault();
                                const userType = "individual";
                                verifyBVN(userType);
                              }}
                            >
                              Verify
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col md="12">
                        <FormGroup>
                          <label className="form-label">Address</label>
                          <input
                            type="text"
                            name="houseNoAddress"
                            placeholder="Address"
                            onChange={(e) => onInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Country of Residence</label>
                          <select
                            className="form-control"
                            name="country"
                            onChange={(e) => {
                              getStates(e.target.value);
                              setFormData({ ...formData, countryId: parseInt(e.target.value) });
                            }}
                            ref={register({
                              required: "This field is required",
                            })}
                          >
                            <option>Select Country</option>
                            {countries ? (
                              <>
                                {countries.map((country) => (
                                  <option value={country.id}>{country.name}</option>
                                ))}
                              </>
                            ) : null}
                          </select>
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">State</label>
                          <select
                            className="form-control"
                            name="state"
                            onChange={(e) => {
                              getLGAs(e.target.value);
                              setFormData({ ...formData, stateId: parseInt(e.target.value) });
                            }}
                            ref={register({
                              required: "This field is required",
                            })}
                          >
                            <option>Select State</option>
                            {states ? (
                              <>
                                {states.map((state) => (
                                  <option value={state.id}>{state.name}</option>
                                ))}
                              </>
                            ) : null}
                          </select>
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">City</label>
                          <input
                            type="text"
                            name="city"
                            placeholder="Input City"
                            onChange={(e) => onInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.city && <span className="invalid">{errors.city.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup>
                          <label className="form-label">Country of Origin</label>
                          <select
                            className="form-control"
                            name="nationality"
                            onChange={(e) => setFormData({ ...formData, nationality: e.target.value })}
                            ref={register({
                              required: "This field is required",
                            })}
                          >
                            <option>Select Country Of Origin</option>
                            {countries ? (
                              <>
                                {countries.map((country) => (
                                  <option value={country.name}>{country.name}</option>
                                ))}
                              </>
                            ) : null}
                          </select>
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup>
                          <label className="form-label">Account Officer</label>
                          <select
                            className="form-control"
                            name="accountOfficerId"
                            onChange={(e) => {
                              setFormData({ ...formData, accountOfficerId: parseInt(e.target.value) });
                              setOfficer(e.target.value);
                            }}
                            ref={register({
                              required: "This field is required",
                            })}
                          >
                            <option>Select Account Officer</option>
                            {accountOfficers || accountOfficers === 0 ? (
                              <>
                                {accountOfficers.map((officer) => (
                                  <option value={officer.useraccount?.id}>{officer.fullName}</option>
                                ))}
                              </>
                            ) : null}
                          </select>
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      {officerIndex ? (
                        <Col md="12">
                          <div className="d-flex justify-content-between align-items-center my-2">
                            <Col md="6">
                              <p className="p-0 m-0">
                                <span className="font-weight-bold">Officer Branch: </span>
                                <span>{accountOfficers[parseInt(officerIndex)].useraccount?.department?.name}</span>
                              </p>
                            </Col>
                            <Col md="6">
                              <p className="p-0 m-0">
                                <span className="font-weight-bold">Officer Department: </span>
                                <span>{accountOfficers[parseInt(officerIndex)].useraccount?.businessUnit?.name}</span>
                              </p>
                            </Col>
                          </div>
                        </Col>
                      ) : null}

                      <Col size="12">
                        <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                          <>
                            {isLoadBtn ? (
                              <Button color="primary" disabled>
                                <Spinner size="sm">Loading...</Spinner>
                                <span> Loading</span>
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                size="md"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  onFormSubmit();
                                }}
                              >
                                Submit
                              </Button>
                            )}
                          </>
                          <>
                            <Button
                              onClick={(ev) => {
                                ev.preventDefault();
                                onFormCancel();
                              }}
                              className="link link-light"
                            >
                              Cancel
                            </Button>
                          </>
                        </ul>
                      </Col>
                    </Form>
                  </Tabs.TabPane>

                  <Tabs.TabPane tab="Corporate" key="2">
                    <Form className="row gy-4" onSubmit={handleSubmit()}>
                      <Col md="12">
                        <div>
                          <h5 className="title">Company Information</h5>
                        </div>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            name="name"
                            // defaultValue={formData.name5
                            placeholder="Company Name"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Company RC Number</label>
                          <input
                            type="number"
                            name="rcNumber"
                            // defaultValue={formData.name5
                            placeholder="RC Number"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Registration Date</label>
                          {/* <input
                            type="text"
                            name="regDate"
                            // defaultValue={formData.name5
                            placeholder="Registration Date"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          /> */}
                          <DatePicker
                            format={dateFormat}
                            onChange={(date, dateString) =>
                              setCompanyFormData({ ...companyFormData, regDate: dateString })
                            }
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Company Address</label>
                          <input
                            type="text"
                            name="address"
                            // defaultValue={formData.name5
                            placeholder="Address"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Company Type</label>
                          <select
                            className="form-control"
                            name="companyType"
                            onChange={(e) => onCompanyInputChange(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                          >
                            <option></option>
                            <option value="SOLE_PROPRIETORSHIP">Sole Proprietorship</option>
                            <option value="PARTNERSHIP">Partnership</option>
                            <option value="CORPORATE_LIMITED">Corporate Limited</option>
                          </select>
                          {errors.status && <span className="invalid">{errors.status.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label className="form-label">Nature Of Business</label>
                          <input
                            type="text"
                            name="natureOfBusiness"
                            // defaultValue={formData.name5
                            placeholder="Nature Of Business"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup>
                          <label className="form-label">Account Officer</label>
                          <select
                            className="form-control"
                            name="accountOfficerId"
                            onChange={(e) => {
                              setCompanyFormData({ ...companyFormData, accountOfficerId: parseInt(e.target.value) });
                              setOfficer(e.target.value);
                            }}
                            ref={register({
                              required: "This field is required",
                            })}
                          >
                            <option>Select Account Officer</option>
                            {accountOfficers ? (
                              <>
                                {accountOfficers.map((officer) => (
                                  <option value={officer.useraccount?.id}>{officer.fullName}</option>
                                ))}
                              </>
                            ) : null}
                          </select>
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      {officerIndex ? (
                        <Col md="12">
                          <div className="d-flex justify-content-between align-items-center my-2">
                            <Col md="6">
                              <p className="p-0 m-0">
                                <span className="font-weight-bold">Officer Branch: </span>
                                <span>{accountOfficers[parseInt(officerIndex)].useraccount?.department?.name}</span>
                              </p>
                            </Col>
                            <Col md="6">
                              <p className="p-0 m-0">
                                <span className="font-weight-bold">Officer Department: </span>
                                <span>{accountOfficers[parseInt(officerIndex)].useraccount?.businessUnit?.name}</span>
                              </p>
                            </Col>
                          </div>
                        </Col>
                      ) : null}

                      <Col md="8">
                        <div>
                          <h5 className="title">Contact Person Information</h5>
                        </div>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Contact Person First Name</label>
                          <input
                            type="text"
                            name="contactPersonFirstName"
                            // defaultValue={formData.name5
                            placeholder="Contact Person First Name"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Contact Person Last Name</label>
                          <input
                            type="text"
                            name="contactPersonLastName"
                            // defaultValue={formData.name5
                            placeholder="Contact Person Last Name"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            name="email"
                            // defaultValue={formData.name5
                            placeholder="Email"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Phone Number</label>
                          <input
                            type="text"
                            name="phoneNumber"
                            placeholder="Phone Number"
                            onChange={(e) => onCompanyInputChange(e)}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.name && <span className="invalid">{errors.name.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col size="12">
                        <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                          <>
                            {isLoadBtn ? (
                              <Button color="primary" disabled>
                                <Spinner size="sm">Loading...</Spinner>
                                <span> Loading</span>
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                size="md"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  addCompanyDash(companyFormData);
                                }}
                              >
                                Submit Details
                              </Button>
                            )}
                          </>
                          <>
                            <Button
                              onClick={(ev) => {
                                ev.preventDefault();
                                onFormCancel();
                              }}
                              className="link link-light"
                            >
                              Cancel
                            </Button>
                          </>
                        </ul>
                      </Col>
                    </Form>
                  </Tabs.TabPane>
                </Tabs>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.edit} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Customer Details</h5>
              {/* Edit for Individual Customers  */}
              {details?.type === "INDIVIDUAL" ? (
                <div className="row gy-4 mt-5">
                  <Col md="4">
                    <Button color="primary" size="md" onClick={() => onEditPersonalInfo()}>
                      Edit Personal Information
                    </Button>
                  </Col>
                  <Col md="4">
                    <Button color="primary" size="md" onClick={() => onEditEmploymentDetails()}>
                      Edit Employment Details
                    </Button>
                  </Col>
                  <Col md="4">
                    <Button color="primary" size="md" onClick={() => onUpdateAccOfficer()}>
                      Update Account Officer
                    </Button>
                  </Col>
                  <div className="mt-5"></div>
                  <Col md="4">
                    <Button color="primary" size="md" onClick={() => onEditNOKDetails()}>
                      Edit NOK Details
                    </Button>
                  </Col>
                  <Col md="4">
                    <Button color="primary" size="md" onClick={() => onEditDocuments()}>
                      Edit Documents
                    </Button>
                  </Col>
                  <Col md="4">
                    <Button color="primary" size="md" onClick={() => onEditBank()}>
                      Edit Bank Account
                    </Button>
                  </Col>
                  <Col md="4">
                    <Button color="primary" size="md" onClick={() => onMakeAccountOfficer()}>
                      Make Account Officer
                    </Button>
                  </Col>
                </div>
              ) : (
                // Edit For Companies
                <div className="row gy-4 mt-5">
                  <Col md="6">
                    <Button color="primary" size="md" onClick={() => onEditCompanyInfo()}>
                      Edit Company Information
                    </Button>
                  </Col>
                  <Col md="6">
                    <Button color="primary" size="md" onClick={() => onEditCompanyDocs()}>
                      Edit Company Document
                    </Button>
                  </Col>
                  <Col md="6">
                    <Button
                      color="primary"
                      size=""
                      onClick={(e) => {
                        e.preventDefault();
                        setNewCompanyUserDetail({
                          ...newCompanyUserDetail,
                          email: details?.useraccount?.email,
                          type: "DIR_ONLY",
                        });
                        setModal({ ...modal, director: true });
                      }}
                    >
                      Add Director
                    </Button>
                  </Col>
                  <Col md="6">
                    <Button color="primary" size="md" onClick={() => onUpdateAccOfficer()}>
                      Update Account Officer
                    </Button>
                  </Col>
                  <Col md="6">
                    <Button color="primary" size="md" onClick={() => onMakeAccountOfficer()}>
                      Make Account Officer
                    </Button>
                  </Col>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.makeAccountOfficer}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Make Account Officer</h5>
              <div className="mt-5">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Official Company Email</label>
                      <input
                        type="email"
                        name="accountOfficerCompanyEmail"
                        placeholder="Enter official company email"
                        value={companyEmail}
                        onChange={(e) => setCompanyEmail(e.target.value)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isAoLoading ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm" />
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button
                            color="primary"
                            size="md"
                            disabled={!companyEmail}
                            onClick={(ev) => {
                              ev.preventDefault();
                              handleMakeAccountOfficer();
                            }}
                          >
                            Confirm
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.editPersonalInfo}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Customer Personal Info</h5>
              <div className="mt-5">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  {/* <Col md="4">
                    <p className="p-0 m-0">
                      <img src={formData?.profilePicture} alt="" style={{ width: "10rem" }} />
                    </p>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Profile Picture</label>
                      <input
                        type="file"
                        name="profilePicture"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeProfilePic(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col> */}
                  <Col md="12">
                    <div>
                      <h5 className="title">Personal Information</h5>
                    </div>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Secondary Phone Number</label>
                      <PhoneInput
                        name="secondaryPhoneNumber"
                        value={formData?.secondaryPhoneNumber}
                        disableCountryCode={true}
                        country={"ng"}
                        onChange={(phone) => {
                          if (phone.length > 13) {
                            toast.error("Input shouldn't exceed 10 characters", {
                              position: toast.POSITION.TOP_CENTER,
                            });
                          } else {
                            setFormData({ ...formData, secondaryPhoneNumber: phone.replace("234", "0") });
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        name="houseNoAddress"
                        defaultValue={formData?.houseNoAddress}
                        onChange={(e) => setFormData({ ...formData, houseNoAddress: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Country of Residence</label>
                      <select
                        className="form-control"
                        name="country"
                        defaultValue={formData?.countryId}
                        onChange={(e) => {
                          getStates(e.target.value);
                          setFormData({ ...formData, countryId: parseInt(e.target.value) });
                        }}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Country</option>
                        {countries ? (
                          <>
                            {countries.map((country) => (
                              <option value={country.id}>{country.name}</option>
                            ))}
                          </>
                        ) : null}
                      </select>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">State</label>
                      <select
                        className="form-control"
                        name="state"
                        defaultValue={formData?.stateId}
                        onChange={(e) => {
                          getLGAs(e.target.value);
                          setFormData({ ...formData, stateId: parseInt(e.target.value) });
                        }}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select State</option>
                        {states?.map((state) => (
                          <option value={state.id}>{state.name}</option>
                        ))}
                      </select>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">City</label>
                      <input
                        type="text"
                        name="city"
                        defaultValue={formData?.city}
                        placeholder="Input City"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" onClick={() => handleEditPersonalInfo(formData)}>
                            Submit
                          </Button>
                        )}
                      </>
                      <>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.editCompanyInfo} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Company Details</h5>
              <Form className="row gy-4" onSubmit={handleSubmit()}>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Company Address</label>
                    <input
                      type="text"
                      name="address"
                      defaultValue={formData?.address}
                      placeholder="Address"
                      onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                      className="form-control"
                      ref={register({
                        required: "This field is required",
                      })}
                    />
                    {errors.name && <span className="invalid">{errors.name.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Company Type</label>
                    <select
                      className="form-control"
                      name="companyType"
                      defaultValue={formData?.companyType}
                      onChange={(e) => setFormData({ ...formData, companyType: e.target.value })}
                      ref={register({
                        required: "This field is required",
                      })}
                    >
                      <option></option>
                      <option value="SOLE_PROPRIETORSHIP">Sole Proprietorship</option>
                      <option value="PARTNERSHIP">Partnership</option>
                      <option value="CORPORATE_LIMITED">Corporate Limited</option>
                    </select>
                    {errors.status && <span className="invalid">{errors.status.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Nature Of Business</label>
                    <input
                      type="text"
                      name="natureOfBusiness"
                      defaultValue={formData?.natureOfBusiness}
                      placeholder="Nature Of Business"
                      onChange={(e) => setFormData({ ...formData, natureOfBusiness: e.target.value })}
                      className="form-control"
                      ref={register({
                        required: "This field is required",
                      })}
                    />
                    {errors.name && <span className="invalid">{errors.name.message}</span>}
                  </FormGroup>
                </Col>

                <Col md="8">
                  <div>
                    <h5 className="title">Contact Person Information</h5>
                  </div>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <label className="form-label">Contact Person First Name</label>
                    <input
                      type="text"
                      name="contactPersonFirstName"
                      defaultValue={formData?.contactPersonFirstName}
                      placeholder="Contact Person First Name"
                      onChange={(e) => setFormData({ ...formData, contactPersonFirstName: e.target.value })}
                      className="form-control"
                      ref={register({
                        required: "This field is required",
                      })}
                    />
                    {errors.name && <span className="invalid">{errors.name.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <label className="form-label">Contact Person Last Name</label>
                    <input
                      type="text"
                      name="contactPersonLastName"
                      defaultValue={formData?.contactPersonLastName}
                      placeholder="Contact Person Last Name"
                      onChange={(e) => setFormData({ ...formData, contactPersonLastName: e.target.value })}
                      className="form-control"
                      ref={register({
                        required: "This field is required",
                      })}
                    />
                    {errors.name && <span className="invalid">{errors.name.message}</span>}
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      defaultValue={formData?.contactPersonEmail}
                      placeholder="Email"
                      onChange={(e) => setFormData({ ...formData, contactPersonEmail: e.target.value })}
                      className="form-control"
                      ref={register({
                        required: "This field is required",
                      })}
                    />
                    {errors.name && <span className="invalid">{errors.name.message}</span>}
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <label className="form-label">Phone Number</label>
                    <input
                      type="text"
                      name="phoneNumber"
                      placeholder="Phone Number"
                      defaultValue={formData?.contactPersonPhoneNo}
                      onChange={(e) => setFormData({ ...formData, contactPersonPhoneNo: e.target.value })}
                      className="form-control"
                      ref={register({
                        required: "This field is required",
                      })}
                    />
                    {errors.name && <span className="invalid">{errors.name.message}</span>}
                  </FormGroup>
                </Col>

                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <>
                      {isLoadBtn ? (
                        <Button color="primary" disabled>
                          <Spinner size="sm">Loading...</Spinner>
                          <span> Loading</span>
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          size="md"
                          onClick={(ev) => {
                            ev.preventDefault();
                            handleEditCompanyInfo(formData);
                          }}
                        >
                          Submit
                        </Button>
                      )}
                    </>
                    <>
                      <Button
                        onClick={(ev) => {
                          ev.preventDefault();
                          onFormCancel();
                        }}
                        className="link link-light"
                      >
                        Cancel
                      </Button>
                    </>
                  </ul>
                </Col>
              </Form>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.director} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Director Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        placeholder="Director First Name"
                        onChange={(e) => setDirectorDetail({ ...directorDetail, firstName: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.firstName && <span className="invalid">{errors.firstName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <label className="form-label">Middle Name</label>
                    <FormGroup>
                      <input
                        type="text"
                        name="middleName"
                        placeholder="Director Middle Name"
                        onChange={(e) => setDirectorDetail({ ...directorDetail, middleName: e.target.value })}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Director Last Name"
                        onChange={(e) => setDirectorDetail({ ...directorDetail, lastName: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.lastName && <span className="invalid">{errors.lastName.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <label className="form-label">Email</label>
                    <FormGroup>
                      <input
                        type="email"
                        name="email"
                        placeholder="Director Email Address"
                        onChange={(e) => setDirectorDetail({ ...directorDetail, email: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">DOB</label>
                      <div>
                        <DatePicker
                          format={dateFormat}
                          onChange={(date, dateString) =>
                            setDirectorDetail({ ...directorDetail, dateOfBirth: dateString })
                          }
                          style={{ width: "20rem" }}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <Tooltip title="Please provide the phone number tied to the BVN">
                      <FormGroup>
                        <label className="form-label">Phone Number</label>
                        <PhoneInput
                          name="phone"
                          placeholder="Phone Number"
                          country={"ng"}
                          onChange={(phone) => {
                            if (phone.length > 13) {
                              toast.error("Input shouldn't exceed 10 characters", {
                                position: toast.POSITION.TOP_CENTER,
                              });
                            } else {
                              setDirectorDetail({ ...directorDetail, phone: phone.replace("234", "0") });
                            }
                          }}
                        />
                      </FormGroup>
                    </Tooltip>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        name="address"
                        placeholder="Director Address"
                        onChange={(e) => setDirectorDetail({ ...directorDetail, address: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.address && <span className="invalid">{errors.address.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <div className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <FormGroup>
                        <label className="form-label">BVN</label>
                        <input
                          type="text"
                          name="bvn"
                          placeholder="BVN"
                          onChange={(e) => setDirectorDetail({ ...directorDetail, bvn: e.target.value })}
                          className="form-control"
                          ref={register({
                            required: "This field is required",
                          })}
                        />
                        {errors.bvn && <span className="invalid">{errors.bvn.message}</span>}
                      </FormGroup>
                      <div>
                        <Button
                          color="primary"
                          size="md"
                          disabled={bvnVerified}
                          onClick={(e) => {
                            e.preventDefault();
                            const userType = "company";
                            verifyBVN(userType);
                          }}
                        >
                          Verify
                        </Button>
                      </div>
                    </div>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Passport Photograph</label>
                      <input
                        type="file"
                        name="passportImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeDirectorImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <select
                        className="form-control"
                        name="idTypeId"
                        onChange={(e) => setDirectorDetail({ ...directorDetail, idTypeId: parseInt(e.target.value) })}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Identification Type</option>
                        {idType?.map((type) => (
                          <option value={type.id}>{type.name}</option>
                        ))}
                      </select>
                      {errors.idTypeId && <span className="invalid">{errors.idTypeId.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">ID Image</label>
                      <input
                        type="file"
                        name="idDocumentImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeDirectorImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">ID Number</label>
                      <input
                        type="text"
                        name="idNumber"
                        placeholder="ID Number"
                        onChange={(e) => setDirectorDetail({ ...directorDetail, idNumber: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    {directorDetail ? (
                      <>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button onClick={() => handleDirectorDetail(directorDetail)} color="primary" size="md">
                            Save
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button disabled color="primary" size="md">
                        Save
                      </Button>
                    )}
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.editDirector} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setModal({ ...modal, editDirector: false });
                resetForm();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Director Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        defaultValue={formData?.firstName}
                        onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <label className="form-label">Middle Name</label>
                    <FormGroup>
                      <input
                        type="text"
                        name="middleName"
                        defaultValue={formData?.middleName}
                        onChange={(e) => setFormData({ ...formData, middleName: e.target.value })}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        defaultValue={formData?.lastName}
                        onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <label className="form-label">Email</label>
                    <FormGroup>
                      <input
                        type="email"
                        name="email"
                        defaultValue={formData?.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Phone Number</label>
                      <PhoneInput
                        name="phone"
                        value={formData?.phone}
                        disableCountryCode={true}
                        country={"ng"}
                        onChange={(phone) => {
                          if (phone.length > 13) {
                            toast.error("Input shouldn't exceed 10 characters", {
                              position: toast.POSITION.TOP_CENTER,
                            });
                          } else {
                            setFormData({ ...formData, phone: phone.replace("234", "0") });
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        name="address"
                        defaultValue={formData?.address}
                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>

                  <Col size="4">
                    <div className="">
                      <img src={formData?.passport} alt="" style={{ width: "6rem" }} />
                    </div>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Passport Photograph</label>
                      <input
                        type="file"
                        name="passportImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeEditDirImage(e)}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <select
                        className="form-control"
                        name="idTypeId"
                        defaultValue={formData?.idTypeId}
                        onChange={(e) => setFormData({ ...formData, idTypeId: parseInt(e.target.value) })}
                      >
                        <option>Select Identification Type</option>
                        {idType?.map((type) => (
                          <option value={type.id}>{type.name}</option>
                        ))}
                      </select>
                    </FormGroup>
                  </Col>

                  <Col size="4">
                    <div className="">
                      <img src={formData?.idImage} alt="" style={{ width: "6rem" }} />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">ID Image</label>
                      <input
                        type="file"
                        name="idDocumentImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeEditDirImage(e)}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">ID Number</label>
                      <input
                        type="text"
                        name="idNumber"
                        defaultValue={formData?.idNumber}
                        onChange={(e) => setFormData({ ...formData, idNumber: e.target.value })}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <Button onClick={() => handleEditDirector(formData)} color="primary" size="md">
                      Save
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.companyDoc} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Company Document</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Certificate of Incorporation</label>
                      <input
                        type="file"
                        name="certificateOfIncoImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  {newCompanyUserDetail?.type === "CORPORATE_LIMITED" ? (
                    <>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Company CAC</label>
                          <input
                            type="file"
                            name="cacImage"
                            accept=".pdf,image/*"
                            className="form-control"
                            onChange={(e) => encodeCompanyImage(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                          />

                          {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Company Memorandum of Association</label>
                          <input
                            type="file"
                            name="moaImage"
                            accept=".pdf,image/*"
                            className="form-control"
                            onChange={(e) => encodeCompanyImage(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                          />

                          {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                        </FormGroup>
                      </Col>
                    </>
                  ) : null}
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Company Utility Bill</label>
                      <input
                        type="file"
                        name="utilityBillImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person Passport</label>
                      <input
                        type="file"
                        name="contactPersonPhotographImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person ID</label>
                      <input
                        type="file"
                        name="contactPersonIdentityImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <select
                        className="form-control"
                        name="idTypeId"
                        onChange={(e) => setCompanyDocument({ ...companyDocument, idTypeId: parseInt(e.target.value) })}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Identification Type</option>
                        {idType?.map((type) => (
                          <option value={type.id}>{type.name}</option>
                        ))}
                      </select>
                      {errors.idTypeId && <span className="invalid">{errors.idTypeId.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person ID Number</label>
                      <input
                        type="text"
                        name="idNumber"
                        placeholder="ID Number"
                        onChange={(e) =>
                          setCompanyDocument({ ...companyDocument, contactPersonIdNumber: e.target.value })
                        }
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <>
                      {isLoadBtn ? (
                        <Button color="primary" disabled>
                          <Spinner size="sm">Loading...</Spinner>
                          <span> Loading</span>
                        </Button>
                      ) : (
                        <Button onClick={() => handleCompanyDocument(companyDocument)} color="primary" size="md">
                          Save
                        </Button>
                      )}
                    </>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.editCompanyDocs} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Company Document</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col size="4">
                    <div className="">
                      <img src={formData?.certificateOfIncoImage} alt="" style={{ width: "10rem" }} />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">Certificate of Incorporation</label>
                      <input
                        type="file"
                        name="certificateOfIncoImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeEditCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  {details?.companyType === "CORPORATE_LIMITED" ? (
                    <>
                      <Col size="4">
                        <div className="">
                          <img src={formData?.cacImage} alt="" style={{ width: "10rem" }} />
                        </div>
                      </Col>
                      <Col md="8">
                        <FormGroup>
                          <label className="form-label">Company CAC</label>
                          <input
                            type="file"
                            name="cacImage"
                            accept="image/*"
                            className="form-control"
                            onChange={(e) => encodeEditCompanyImage(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                          />

                          {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                        </FormGroup>
                      </Col>

                      <Col size="4">
                        <div className="">
                          <img src={formData?.moaImage} alt="" style={{ width: "10rem" }} />
                        </div>
                      </Col>
                      <Col md="8">
                        <FormGroup>
                          <label className="form-label">Company Memorandum of Association</label>
                          <input
                            type="file"
                            name="moaImage"
                            accept="image/*"
                            className="form-control"
                            onChange={(e) => encodeEditCompanyImage(e)}
                            ref={register({
                              required: "This field is required",
                            })}
                          />

                          {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                        </FormGroup>
                      </Col>
                    </>
                  ) : null}

                  <Col size="4">
                    <div className="">
                      <img src={formData?.utilityBillImage} alt="" style={{ width: "10rem" }} />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">Company Utility Bill</label>
                      <input
                        type="file"
                        name="utilityBillImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeEditCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="4">
                    <div className="">
                      <img src={formData?.contactPersonPhotographImage} alt="" style={{ width: "10rem" }} />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">Contact Person Passport</label>
                      <input
                        type="file"
                        name="contactPersonPhotographImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeEditCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="4">
                    <div className="">
                      <img src={formData?.contactPersonIdentityImage} alt="" style={{ width: "10rem" }} />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">Contact Person ID</label>
                      <input
                        type="file"
                        name="contactPersonIdentityImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeEditCompanyImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <select
                        className="form-control"
                        name="idTypeId"
                        defaultValue={companyDocument?.idTypeId}
                        onChange={(e) => setCompanyDocument({ ...companyDocument, idTypeId: parseInt(e.target.value) })}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Identification Type</option>
                        {idType?.map((type) => (
                          <option value={type.id}>{type.name}</option>
                        ))}
                      </select>
                      {errors.idTypeId && <span className="invalid">{errors.idTypeId.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Contact Person ID Number</label>
                      <input
                        type="text"
                        name="idNumber"
                        defaultValue={companyDocument?.contactPersonIdNumber}
                        onChange={(e) =>
                          setCompanyDocument({ ...companyDocument, contactPersonIdNumber: e.target.value })
                        }
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button onClick={() => handleEditCompanyDocument(companyDocument)} color="primary" size="md">
                      Save
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.employmentDetail}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Employment Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="6">
                    <FormGroup>
                      <input
                        type="text"
                        name="Occupation"
                        placeholder="Input Occupation"
                        onChange={(e) => setEmploymentDetails({ ...employmentDetail, occupation: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <input
                        type="text"
                        name="Employer Name"
                        placeholder="Employer Name"
                        onChange={(e) => setEmploymentDetails({ ...employmentDetail, employerName: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <input
                        type="text"
                        name="Employer Address"
                        placeholder="Employer Address"
                        onChange={(e) => setEmploymentDetails({ ...employmentDetail, employerAddress: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    {employmentDetail ? (
                      <>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button onClick={() => handleEmploymentDetail(employmentDetail)} color="primary" size="md">
                            Save
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button disabled color="primary" size="md">
                        Save
                      </Button>
                    )}
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.editEmploymentDetail}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Employment Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Occupation</label>
                      <input
                        type="text"
                        name="Occupation"
                        defaultValue={formData?.occupation}
                        onChange={(e) => setFormData({ ...formData, occupation: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Employer Name</label>
                      <input
                        type="text"
                        name="Employer Name"
                        defaultValue={formData?.employerName}
                        onChange={(e) => setFormData({ ...formData, employerName: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Employer Address</label>
                      <input
                        type="text"
                        name="Employer Address"
                        defaultValue={formData?.employerAddress}
                        onChange={(e) => setFormData({ ...formData, employerAddress: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button
                      color="primary"
                      size="md"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEditEmploymentDetails(formData);
                      }}
                    >
                      Save
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.nokDetail} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Next of Kin Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="6">
                    <FormGroup>
                      <input
                        type="email"
                        name="NOK Email"
                        placeholder="Input Email"
                        onChange={(e) => setNokDetails({ ...nokDetail, email: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <input
                        type="text"
                        name="NOK Name"
                        placeholder="Name"
                        onChange={(e) => setNokDetails({ ...nokDetail, name: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <input
                        type="text"
                        name="NOK Phone"
                        placeholder="Phone Number"
                        onChange={(e) => setNokDetails({ ...nokDetail, phone: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <input
                        type="text"
                        name="NOK Address"
                        placeholder="Address"
                        onChange={(e) => setNokDetails({ ...nokDetail, nokAddress: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    {nokDetail ? (
                      <>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button onClick={() => handleNokDetail(nokDetail)} color="primary" size="md">
                            Save
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button disabled color="primary" size="md">
                        Save
                      </Button>
                    )}
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.editNOKDetail} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setFormData({});
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Next of Kin Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">NOK Email</label>
                      <input
                        type="email"
                        name="NOK Email"
                        defaultValue={formData?.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">NOK Name</label>
                      <input
                        type="text"
                        name="NOK Name"
                        defaultValue={formData?.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">NOK Phone Number</label>
                      <input
                        type="text"
                        name="NOK Phone"
                        defaultValue={formData?.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">NOK Address</label>
                      <input
                        type="text"
                        name="NOK Address"
                        defaultValue={formData?.address}
                        onChange={(e) => setFormData({ ...formData, nokAddress: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button onClick={() => handleEditNokDetails(formData)} color="primary" size="md">
                      Save
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.customerDocs} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Documents</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Passport Photograph</label>
                      <input
                        type="file"
                        name="passportPhotographImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Utility Bill Image</label>
                      <input
                        type="file"
                        name="utilityBillImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <select
                        className="form-control"
                        name="idTypeId"
                        onChange={(e) =>
                          setCustomerDocuments({ ...customerDocuments, idTypeId: parseInt(e.target.value) })
                        }
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Identification Type</option>
                        {idType?.map((type) => (
                          <option value={type.id}>{type.name}</option>
                        ))}
                      </select>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">ID Image</label>
                      <input
                        type="file"
                        name="idDocumentImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeImage(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">ID Number</label>
                      <input
                        type="text"
                        name="idNumber"
                        placeholder="ID Number"
                        onChange={(e) => setCustomerDocuments({ ...customerDocuments, idNumber: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <>
                      {isLoadBtn ? (
                        <Button color="primary" disabled>
                          <Spinner size="sm">Loading...</Spinner>
                          <span> Loading</span>
                        </Button>
                      ) : (
                        <Button onClick={() => handleCustomerDocuments(customerDocuments)} color="primary" size="md">
                          Save
                        </Button>
                      )}
                    </>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.editDocuments} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Documents</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col size="4">
                    <div className="">
                      <img
                        src={details?.myDocument?.passportPhotographImage?.imageUrl}
                        alt=""
                        style={{ width: "10rem" }}
                      />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">Passport Photograph</label>
                      <input
                        type="file"
                        name="passportPhotographImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeImageEdit(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="4">
                    <div className="">
                      <img src={details?.myDocument?.utilityBillImage?.imageUrl} alt="" style={{ width: "10rem" }} />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">Utility Bill Image</label>
                      <input
                        type="file"
                        name="utilityBillImage"
                        accept="image/*"
                        className="form-control"
                        onChange={(e) => encodeImageEdit(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Identification Type</label>
                      <select
                        className="form-control"
                        name="idTypeId"
                        defaultValue={formData.idTypeId}
                        onChange={(e) => setFormData({ ...formData, idTypeId: parseInt(e.target.value) })}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Identification Type</option>
                        {idType?.map((type) => (
                          <option value={type.id}>{type.name}</option>
                        ))}
                      </select>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="4">
                    <div className="">
                      <img src={details?.myDocument?.idDocumentImage?.imageUrl} alt="" style={{ width: "10rem" }} />
                    </div>
                  </Col>
                  <Col md="8">
                    <FormGroup>
                      <label className="form-label">ID Image</label>
                      <input
                        type="file"
                        name="idDocumentImage"
                        accept=".pdf,image/*"
                        className="form-control"
                        onChange={(e) => encodeImageEdit(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      />

                      {errors.imageUrl && <span className="invalid">{errors.imageUrl.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">ID Number</label>
                      <input
                        type="text"
                        name="idNumber"
                        defaultValue={formData?.idNumber}
                        onChange={(e) => setFormData({ ...formData, idNumber: e.target.value })}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button onClick={() => handleEditDocuments(formData)} color="primary" size="md">
                      {handleEditLoading ? "Loading" : "Save"}
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.bankDetails} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Bank Account Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Bank</label>
                      <select
                        className="form-control"
                        name="bankCode"
                        onChange={(e) => setBankAccDetails({ ...bankAccDetails, bankCode: e.target.value })}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Bank</option>
                        {banks ? (
                          <>
                            {banks.map((bank) => (
                              <option value={bank.code}>{bank.name}</option>
                            ))}
                          </>
                        ) : null}
                      </select>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <div className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <div>
                        <FormGroup>
                          <input
                            type="number"
                            name="accountNumber"
                            placeholder="Input Account Number"
                            onChange={(e) => setBankAccDetails({ ...bankAccDetails, accountNumber: e.target.value })}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                        </FormGroup>
                      </div>
                      <div>
                        <Button
                          color="primary"
                          size="md"
                          onClick={(e) => {
                            e.preventDefault();
                            verifyBankAccount("ADD");
                          }}
                        >
                          Verify
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <input
                        disabled
                        type="text"
                        name="accountName"
                        value={bankAccDetails?.accountName}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    {bankAccDetails ? (
                      <>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button onClick={() => handleBankAccDetails(bankAccDetails)} color="primary" size="md">
                            Save
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button disabled color="primary" size="md">
                        Save
                      </Button>
                    )}
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.editBank} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Bank Account Details</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Bank</label>
                      <select
                        className="form-control"
                        name="bankCode"
                        defaultValue={formData.bankCode}
                        onChange={(e) => setFormData({ ...formData, bankCode: e.target.value })}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Bank</option>
                        {banks ? (
                          <>
                            {banks.map((bank) => (
                              <option value={bank.code}>{bank.name}</option>
                            ))}
                          </>
                        ) : null}
                      </select>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <div className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <div>
                        <FormGroup>
                          <input
                            type="number"
                            name="accountNumber"
                            placeholder="Input Account Number"
                            defaultValue={formData.accountNumber}
                            onChange={(e) => setFormData({ ...formData, accountNumber: e.target.value })}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {errors.reason && <span className="invalid">{errors.reason.message}</span>}
                        </FormGroup>
                      </div>
                      <div>
                        <Button
                          color="primary"
                          size="md"
                          onClick={(e) => {
                            e.preventDefault();
                            verifyBankAccount("EDIT");
                          }}
                        >
                          Verify
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <input
                        disabled
                        type="text"
                        name="accountName"
                        value={formData?.accountName}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <Button onClick={() => handleEditBankAccDetails(formData)} color="primary" size="md">
                      Save
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.updateAccOfficer}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Update Account Officer</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit()}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Account Officer</label>
                      <select
                        className="form-control"
                        name="accountOfficerId"
                        defaultValue={formData.accountOfficerId}
                        onChange={(e) => setFormData({ ...formData, accountOfficerId: parseInt(e.target.value) })}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option>Select Officer</option>
                        {accOfficers ? (
                          <>
                            {accOfficers.map((officer) => (
                              <option value={officer.id}>{officer.name}</option>
                            ))}
                          </>
                        ) : null}
                      </select>
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <Button onClick={() => handleUpdateAccOfficer(formData)} color="primary" size="md">
                      Update
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.view} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">View Customer</h5>
              <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
                <div>
                  <span className="font-weight-bold">Account Status: </span>
                  <span className={`ml-1 badge badge-dot badge-${details?.accountStatus === "ACTIVE" ? "success" : "danger"}`}>
                    {details?.accountStatus}
                  </span>
                </div>
                {(details?.accountStatus === "INACTIVE") && (
                  <Button color="success" size="md" onClick={openReactivateModal}>
                    Reactivate Account
                  </Button>
                )}
              </div>
              {details?.type === "INDIVIDUAL" ? (
                <>
                  <div className="mt-4">
                   {details?.myDocument?.passportPhotographImage?.imageUrl && <Col md="4">
                      <p className="p-0 m-0">
                        <img
                          src={details?.myDocument?.passportPhotographImage?.imageUrl}
                          alt=""
                          style={{ width: "10rem" }}
                        />
                      </p>
                    </Col>}
                    <Col md="12">
                      <h6 className="title">Personal Information</h6>
                    </Col>
                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">First Name: </span>
                          <span>{details?.firstName}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Middle Name: </span>
                          <span>{details?.individualUser?.middleName}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Last Name: </span>
                          <span>{details?.lastName}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Gender: </span>
                          <span>{details?.gender?.gender}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">DOB: </span>
                          <span>{details?.individualUser?.dateOfBirth}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Primary Phone No: </span>
                          <span>{details?.phoneNumber}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Email: </span>
                          <span>{details?.email}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">BVN: </span>
                          <span>{details?.individualUser?.bvn}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Customer ID: </span>
                          <span>{details?.customerId}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Secondary Phone Number: </span>
                          <span>{details?.secondaryPhoneNumber}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Address: </span>
                          <span>{details?.addressObject?.houseNoAddress}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Country of Residence: </span>
                          <span>{details?.countryOfResidence?.name}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">State: </span>
                          <span>{details?.addressObject?.state}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">City: </span>
                          <span>{details?.addressObject?.city}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Nationality: </span>
                          <span>{details?.addressObject?.nationality}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="mt-5">
                      <Col md="12">
                        <h6 className="title">Next of Kin</h6>
                      </Col>

                      <div className="d-flex justify-content-between align-items-center my-2">
                        <Col md="6">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Name: </span>
                            <span>{details?.nokDetail?.name}</span>
                          </p>
                        </Col>
                        <Col md="6">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Address: </span>
                            <span>{details?.nokDetail?.address}</span>
                          </p>
                        </Col>
                      </div>

                      <div className="d-flex justify-content-between align-items-center my-2">
                        <Col md="6">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Phone Number: </span>
                            <span>{details?.nokDetail?.phone}</span>
                          </p>
                        </Col>
                        <Col md="6">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Email: </span>
                            <span>{details?.nokDetail?.email}</span>
                          </p>
                        </Col>
                      </div>
                    </div>

                    <div className="mt-5">
                      <Col md="12">
                        <h6 className="title">Employment Details</h6>
                      </Col>

                      <div className="d-flex justify-content-between align-items-center my-2">
                        <Col md="4">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Occupation: </span>
                            <p>{details?.employmentDetail?.occupation}</p>
                          </p>
                        </Col>
                        <Col md="4">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Employer Name: </span>
                            <p>{details?.employmentDetail?.employerName}</p>
                          </p>
                        </Col>
                        <Col md="4">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Employer Address: </span>
                            <p>{details?.employmentDetail?.employerAddress}</p>
                          </p>
                        </Col>
                      </div>
                    </div>

                    <div className="mt-5">
                      <Col md="12">
                        <h6 className="title">Customer Documents</h6>
                      </Col>

                      <div className="d-flex justify-content-between align-items-center my-2">
                        <Col md="4">
                          <span className="font-weight-bold">Customer ID</span>
                          <div>
                            <Button
                              color="primary"
                              size="lg"
                              onClick={(e) => {
                                setDocView("ID");
                                setModal({ ...modal, viewDoc: true });
                              }}
                            >
                              View Document
                            </Button>
                          </div>
                        </Col>
                        <Col md="4">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">ID Number: </span>
                            <p>{details?.myDocument?.idNumber}</p>
                          </p>
                        </Col>
                        <Col md="4">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">ID Type: </span>
                            <p>{details?.myDocument?.idType?.name}</p>
                          </p>
                        </Col>
                      </div>

                      <div className="d-flex justify-content-between align-items-center my-2 mt-5">
                        <Col md="4">
                          <span className="font-weight-bold">Utility Bill: </span>
                          <div>
                            <Button
                              color="primary"
                              size="lg"
                              onClick={(e) => {
                                setDocView("Utility");
                                setModal({ ...modal, viewDoc: true });
                              }}
                            >
                              View Document
                            </Button>
                          </div>
                        </Col>
                      </div>
                    </div>

                    <div className="mt-5">
                      <Col md="12">
                        <h6 className="title">Bank Details</h6>
                      </Col>

                      <div className="d-flex justify-content-between align-items-center my-2">
                        <Col md="6">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Bank Name: </span>
                            <span>{userBankDetails?.bank?.name}</span>
                          </p>
                        </Col>
                      </div>

                      <div className="d-flex justify-content-between align-items-center my-2">
                        <Col md="6">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Account Name: </span>
                            <span>{userBankDetails?.accountName}</span>
                          </p>
                        </Col>
                        <Col md="6">
                          <p className="p-0 m-0">
                            <span className="font-weight-bold">Account Number: </span>
                            <span>{userBankDetails?.accountNumber}</span>
                          </p>
                        </Col>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="mt-5">
                    <Col md="12">
                      <h6 className="title">Company Details</h6>
                    </Col>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Company ID: </span>
                          <span>{details?.useraccount?.customerId}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Company Name: </span>
                          <span>{details?.name}</span>
                        </p>
                      </Col>
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">RC Number: </span>
                          <span>{details?.rcNumber}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Reg Date: </span>
                          <span>{details?.dateOfInco}</span>
                        </p>
                      </Col>
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Address: </span>
                          <span>{details?.companyAddress}</span>
                        </p>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Company Type: </span>
                          <span>{details?.companyType}</span>
                        </p>
                      </Col>
                      <Col md="6">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Nature of Business: </span>
                          <span>{details?.natureOfBusiness}</span>
                        </p>
                      </Col>
                    </div>
                  </div>

                  <div className="mt-5">
                    <Col md="12">
                      <h6 className="title">Contact Person Details</h6>
                    </Col>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Name: </span>
                          <span>
                            {details?.contactFirstName} {details?.contactLastName}
                          </span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Phone Number: </span>
                          <span>{details?.useraccount?.phone}</span>
                        </p>
                      </Col>
                      <Col md="4">
                        <p className="p-0 m-0">
                          <span className="font-weight-bold">Email Address: </span>
                          <span>{details?.useraccount?.email}</span>
                        </p>
                      </Col>
                    </div>
                  </div>

                  <div className="mt-5">
                    <div className="d-flex justify-content-between align-items-center my-2">
                      <div>
                        <h6 className="title">Director Details</h6>
                      </div>
                      <div></div>
                    </div>

                    {details?.directorDetails?.map((director) => (
                      <>
                        <div className="mt-5 d-flex justify-content-between align-items-center my-2">
                          <Col md="2">
                            <p className="p-0 m-0">
                              <img src={director?.passportImage?.imageUrl} alt="" style={{ width: "5rem" }} />
                            </p>
                          </Col>
                          <Col md="7">
                            <p className="p-0 m-0">
                              <span className="font-weight-bold">Name: </span>
                              <span>
                                {director?.firstName} {director?.middleName} {director?.lastName}
                              </span>
                            </p>
                          </Col>
                          <Col md="3">
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => {
                                setSingleDirectorDetail(
                                  details?.directorDetails?.filter((dir) => dir.id === director.id)
                                );
                                setModal({ ...modal, viewDirector: true });
                              }}
                            >
                              See More
                            </Button>
                          </Col>
                        </div>
                      </>
                    ))}
                  </div>

                  <div className="mt-5">
                    <Col md="12">
                      <h6 className="title">Company Documents</h6>
                    </Col>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 mb-2">
                          <span className="font-weight-bold">Cetificate of Incorporation: </span>
                        </p>
                        <div>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={(e) => {
                              setDocView("COI");
                              setModal({ ...modal, viewDoc: true });
                            }}
                          >
                            View
                          </Button>
                        </div>
                      </Col>
                      <Col md="4">
                        <p className="p-0 mb-2">
                          <span className="font-weight-bold">Company CAC: </span>
                        </p>
                        <div>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={(e) => {
                              setDocView("CAC");
                              setModal({ ...modal, viewDoc: true });
                            }}
                          >
                            View
                          </Button>
                        </div>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 mb-2">
                          <span className="font-weight-bold">Company MOA: </span>
                        </p>
                        <div>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={(e) => {
                              setDocView("MOA");
                              setModal({ ...modal, viewDoc: true });
                            }}
                          >
                            View
                          </Button>
                        </div>
                      </Col>
                      <Col md="4">
                        <p className="p-0 mb-2">
                          <span className="font-weight-bold">Company Contact Person Passport: </span>
                        </p>
                        <div>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={(e) => {
                              setDocView("CPP");
                              setModal({ ...modal, viewDoc: true });
                            }}
                          >
                            View
                          </Button>
                        </div>
                      </Col>
                    </div>

                    <div className="d-flex justify-content-between align-items-center my-2">
                      <Col md="4">
                        <p className="p-0 mb-2">
                          <span className="font-weight-bold">Contact Person ID: </span>
                        </p>
                        <div>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={(e) => {
                              setDocView("CPI");
                              setModal({ ...modal, viewDoc: true });
                            }}
                          >
                            View
                          </Button>
                        </div>
                      </Col>
                      <Col md="4">
                        <p className="p-0 mb-2">
                          <span className="font-weight-bold">Company Utility Bill: </span>
                        </p>
                        <div>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={(e) => {
                              setDocView("CUB");
                              setModal({ ...modal, viewDoc: true });
                            }}
                          >
                            View
                          </Button>
                        </div>
                      </Col>
                    </div>
                  </div>
                </>
              )}
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.reactivate}
          toggle={closeReactivateModal}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                closeReactivateModal();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Reactivate Account</h5>
              <p className="mt-2 text-soft">
                Are you sure you want to reactivate this account? Please provide a reason below.
              </p>
              <div className="mt-3">
                <p className="p-0 m-0">
                  <span className="font-weight-bold">Email Address: </span>
                  <span>{details?.email || details?.useraccount?.email}</span>
                </p>
              </div>
              <FormGroup className="mt-3">
                <label className="form-label font-weight-bold" htmlFor="reactivate-reason">
                  Reason for Reactivation
                </label>
                <textarea
                  id="reactivate-reason"
                  className="form-control"
                  rows="3"
                  placeholder="Enter reason for reactivation (minimum 10 characters)"
                  value={reactivateReason}
                  onChange={(ev) => setReactivateReason(ev.target.value)}
                />
                <span className="form-note mt-1">{reactivateReason.trim().length}/10 characters minimum</span>
              </FormGroup>
              <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2 mt-3">
                <li>
                  {isReactivateLoading ? (
                    <Button color="success" disabled>
                      <Spinner size="sm">Loading...</Spinner>
                      <span> Loading</span>
                    </Button>
                  ) : (
                    <Button
                      color="success"
                      size="md"
                      disabled={reactivateReason.trim().length < 10}
                      onClick={(ev) => {
                        ev.preventDefault();
                        handleReactivateAccount();
                      }}
                    >
                      Confirm Reactivation
                    </Button>
                  )}
                </li>
                <li>
                  <Button
                    onClick={(ev) => {
                      ev.preventDefault();
                      closeReactivateModal();
                    }}
                    className="link link-light"
                  >
                    Cancel
                  </Button>
                </li>
              </ul>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.viewDoc}
          toggle={() => {
            setDocView(undefined);
            setModal({ ...modal, viewDoc: false });
          }}
          style={{ maxWidth: "100vw", width: "100%" }}
          contentClassName="my-modal"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                setDocView(undefined);
                setModal({ ...modal, viewDoc: false });
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>

            <div>
              {docView === "ID" ? (
                <iframe
                  title="ID Document"
                  frameborder="0"
                  src={details?.myDocument?.idDocumentImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "Utility" ? (
                <iframe
                  title="Utility Document"
                  frameborder="0"
                  src={details?.myDocument?.utilityBillImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "DirPassport" ? (
                <iframe
                  title="Director Passport"
                  frameborder="0"
                  src={singleDirectorDetail[0]?.passportImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "DirDoc" ? (
                <iframe
                  title="Director Document"
                  frameborder="0"
                  src={singleDirectorDetail[0]?.idDocumentImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "COI" ? (
                <iframe
                  title="Certificate of Inco"
                  frameborder="0"
                  src={details?.companyDocument?.certificateOfIncoImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "CAC" ? (
                <iframe
                  title="CAC Document"
                  frameborder="0"
                  src={details?.companyDocument?.cacImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "MOA" ? (
                <iframe
                  title="MOA Document"
                  frameborder="0"
                  src={details?.companyDocument?.moaImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "CPP" ? (
                <iframe
                  title="Contact Person Passport"
                  frameborder="0"
                  src={details?.companyDocument?.contactPersonPhotographImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "CPI" ? (
                <iframe
                  title="Contact Person ID Document"
                  frameborder="0"
                  src={details?.companyDocument?.contactPersonIdImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}

              {docView === "CUB" ? (
                <iframe
                  title="Company Utility Document"
                  frameborder="0"
                  src={details?.companyDocument?.utilityBillImage?.imageUrl}
                  width="100%"
                  height="800px"
                ></iframe>
              ) : null}
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.viewDirector}
          toggle={() => setModal({ viewDirector: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setModal({ viewDirector: false });
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="mt-5">
              {singleDirectorDetail?.map((director) => (
                <>
                  <div className="d-flex justify-content-between align-items-center my-2">
                    <Col md="4">
                      <p className="p-0 mb-2">
                        <p className="p-0 m-0">
                          <img src={director?.passportImage?.imageUrl} alt="" style={{ width: "6rem" }} />
                        </p>
                      </p>
                      <div>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={(e) => {
                            setDocView("DirPassport");
                            setModal({ ...modal, viewDoc: true });
                          }}
                        >
                          View
                        </Button>
                      </div>
                    </Col>
                    <div>
                      <AllowAccess allowedRights={["EDIT_CUSTOMER"]}>
                        <Button
                          color="primary"
                          size="md"
                          onClick={(e) => {
                            setModal({ ...modal, editDirector: true });
                            setFormData({
                              address: director?.address,
                              bvn: director?.bvn,
                              email: director?.email,
                              firstName: director?.firstName,
                              id: director?.id,
                              // "idDocumentImage": "string",
                              idImage: director?.idDocumentImage?.imageUrl,
                              idNumber: director?.idNumber,
                              idTypeId: director?.idType?.id,
                              lastName: director?.lastName,
                              middleName: director?.middleName,
                              // "passportImage": "string",
                              passport: director?.passportImage?.imageUrl,
                              phone: director?.phone,
                            });
                          }}
                        >
                          Edit
                        </Button>
                      </AllowAccess>
                    </div>
                  </div>

                  <div className="mt-5 d-flex justify-content-between align-items-center my-2">
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">First Name</span>
                        <p className="p-0 m-0">{director?.firstName}</p>
                      </p>
                    </Col>
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Middle Name</span>
                        <p className="p-0 m-0">{director?.middleName}</p>
                      </p>
                    </Col>
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Last Name</span>
                        <p className="p-0 m-0">{director?.lastName}</p>
                      </p>
                    </Col>
                  </div>

                  <div className="d-flex justify-content-between align-items-center my-2">
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Email</span>
                        <p className="p-0 m-0">{director?.email}</p>
                      </p>
                    </Col>
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Phone</span>
                        <p className="p-0 m-0">{director?.phone}</p>
                      </p>
                    </Col>
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Address</span>
                        <p className="p-0 m-0">{director?.address}</p>
                      </p>
                    </Col>
                  </div>

                  <div className="mt-5 d-flex justify-content-between align-items-center my-2">
                    <Col md="4">
                      <p className="p-0 title m-0">Director Document</p>
                    </Col>
                  </div>

                  <div className="d-flex justify-content-between align-items-center my-2">
                    <Col md="4">
                      <p className="p-0 mb-2">
                        <p className="p-0 m-0">
                          <img src={director?.idDocumentImage?.imageUrl} alt="" style={{ width: "10rem" }} />
                        </p>
                      </p>
                      <div className="mb-5">
                        <Button
                          color="primary"
                          size="sm"
                          onClick={(e) => {
                            setDocView("DirDoc");
                            setModal({ ...modal, viewDoc: true });
                          }}
                        >
                          View
                        </Button>
                      </div>
                    </Col>
                  </div>

                  <div className="d-flex justify-content-between align-items-center my-2">
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">ID Number</span>
                        <p className="p-0 m-0">{director?.idNumber}</p>
                      </p>
                    </Col>
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">ID Type</span>
                        <p className="p-0 m-0">{director?.idType?.name}</p>
                      </p>
                    </Col>
                    <Col md="4">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">BVN</span>
                        <p className="p-0 m-0">{director?.bvn}</p>
                      </p>
                    </Col>
                  </div>
                </>
              ))}
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal.investment} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <InvestmentWrapper>
              <h5 className="title">Create Investment: {selectedCustomer?.email}</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(handleCreateInvestment)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Customer Name</label>
                      <input
                        type="text"
                        name="customerName"
                        disabled
                        placeholder="Enter Customer Name"
                        onChange={handleInvestmentInputChange}
                        className="form-control"
                        value={
                          selectedCustomer?.type === "INDIVIDUAL"
                            ? `${selectedCustomer?.firstName} ${selectedCustomer?.lastName}`
                            : selectedCustomer?.companyName
                        }
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Plan Name</label>
                      <input
                        type="text"
                        name="planName"
                        placeholder="Enter A Plan Name"
                        onChange={handleInvestmentInputChange}
                        className={`form-control ${
                          createInvestmentFormData.planName === "" && touched ? "is-invalid" : ""
                        }`}
                        value={createInvestmentFormData?.planName}
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Product Name</label>
                      <RSelect
                        options={productOptions}
                        value={productOptions.filter(({ value }) => value === createInvestmentFormData?.product)[0]}
                        placeholder="Please select a Product"
                        onChange={(e) => handleInvestmentSelectChange(e, "product")}
                        invalid={createInvestmentFormData.product === "" && touched}
                      />

                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Currency</label>
                      <RSelect
                        options={currencyOptions}
                        value={currencyOptions.filter(({ value }) => value === createInvestmentFormData?.currency)[0]}
                        placeholder="Select Investment Currency"
                        onChange={(e) => handleInvestmentSelectChange(e, "currency")}
                        invalid={createInvestmentFormData.currency === "" && touched}
                      />

                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  {createInvestmentFormData.currency !== 8 && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Exchange Rate</label>
                        <input
                          disabled
                          name="exchangeRate"
                          placeholder="Enter Exchange Rate"
                          type="text"
                          value={`${"₦"}  ${createInvestmentFormData?.exchangeRate}`}
                          onChange={handleInvestmentInputChange}
                          className="form-control"
                          ref={register({
                            required: "This field is required",
                          })}
                        />
                        {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  {!singleProduct?.properties?.hasTargetAmount && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Investment Amount</label>
                        <div className="input-group">
                          <div className="input-group-prepend curr-icon">
                            {getCurrencyIcon(createInvestmentFormData.currency)}
                          </div>
                          <input
                            type="number"
                            name="amount"
                            placeholder="Input Investment Amount"
                            value={createInvestmentFormData?.amount}
                            onChange={handleInvestmentInputChange}
                            className={`form-control ${createInvestmentFormData.currency !== "" && "curr-input"} ${
                              createInvestmentFormData.amount < singleProduct?.minTransactionLimit ||
                              (createInvestmentFormData.amount > singleProduct?.maxTransactionLimit && touched)
                                ? "is-invalid"
                                : ""
                            }`}
                            min={singleProduct?.minTransactionLimit}
                            max={singleProduct?.maxTransactionLimit}
                            disabled={singleProduct?.properties?.hasTargetAmount}
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                        </div>
                        {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  {singleProduct?.properties?.hasTargetAmount && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Target Amount</label>
                        <div className="input-group">
                          <div className="input-group-prepend curr-icon">
                            {getCurrencyIcon(createInvestmentFormData.currency)}
                          </div>
                          <input
                            type="number"
                            name="targetAmount"
                            className={`form-control ${createInvestmentFormData.currency !== "" && "curr-input"} ${
                              createInvestmentFormData.targetAmount < singleProduct?.minTransactionLimit ||
                              (createInvestmentFormData.targetAmount > singleProduct?.maxTransactionLimit && touched)
                                ? "is-invalid"
                                : ""
                            }`}
                            value={createInvestmentFormData?.targetAmount}
                            placeholder="Enter Target Amount"
                            onChange={handleInvestmentInputChange}
                            disabled={
                              singleProduct?.properties?.hasTargetAmount === null ||
                              !singleProduct?.properties?.hasTargetAmount
                            }
                            min={singleProduct?.minTransactionLimit}
                            max={singleProduct?.maxTransactionLimit}
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                        </div>
                        {singleProduct?.properties?.hasTargetAmount &&
                        createInvestmentFormData.targetAmount < singleProduct?.minTransactionLimit ? (
                          <small className="helper-text">
                            Target value cannot be below {singleProduct?.minTransactionLimit}
                          </small>
                        ) : (
                          <></>
                        )}
                        {singleProduct?.properties?.hasTargetAmount &&
                        createInvestmentFormData.targetAmount > singleProduct?.maxTransactionLimit ? (
                          <small className="helper-text">
                            Target value cannot be above {singleProduct?.maxTransactionLimit}
                          </small>
                        ) : (
                          <></>
                        )}
                        {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Investment Value Date</label>
                      <input
                        type="date"
                        name="investmentValueDate"
                        onChange={handleInvestmentInputChange}
                        value={createInvestmentFormData?.investmentValueDate}
                        className={`form-control ${
                          createInvestmentFormData.investmentValueDate === "" && touched ? "is-invalid" : ""
                        }`}
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Tenor</label>
                      <RSelect
                        options={tenorOptions}
                        value={tenorOptions.filter(({ value }) => value === createInvestmentFormData?.tenor)}
                        placeholder="Select Tenor"
                        onChange={(e) => handleInvestmentSelectChange(e, "tenor")}
                        invalid={createInvestmentFormData.tenor === "" && touched}
                      />

                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  {createInvestmentFormData.tenor === 0 && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Tenor [Actual Maturity Date]</label>
                        <input
                          className="form-control"
                          name="actualMaturityDate"
                          placeholder=""
                          type="date"
                          min={moment(minTenor).format("YYYY-MM-DD")}
                          max={moment(maxTenor).format("YYYY-MM-DD")}
                          value={createInvestmentFormData.actualMaturityDate}
                          onChange={handleInvestmentInputChange}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {singleProduct?.properties?.hasSavingFrequency && (
                    <>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Savings Frequency</label>
                          <RSelect
                            options={savingFrequencyOptions}
                            value={
                              savingFrequencyOptions.filter(
                                ({ value }) => value === createInvestmentFormData?.savingFrequency
                              )[0]
                            }
                            invalid={createInvestmentFormData.savingFrequency === "" && touched}
                            onChange={(e) => handleInvestmentSelectChange(e, "savingFrequency")}
                          />

                          {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                        </FormGroup>
                      </Col>
                      {createInvestmentFormData?.savingFrequency === "MONTHLY" && (
                        <Col md="6">
                          <FormGroup>
                            <label className="form-label">Set Monthly Contibution Day</label>
                            <RSelect
                              options={monthsOptions}
                              value={
                                monthsOptions.filter(
                                  (value) => value === createInvestmentFormData?.monthlyContributionDay
                                )[0]
                              }
                              invalid={
                                singleProduct?.properties?.hasSavingFrequency &&
                                createInvestmentFormData.savingFrequency === "MONTHLY" &&
                                touched
                              }
                              onChange={(e) => handleInvestmentSelectChange(e, "monthlyContributionDay")}
                            />

                            {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                          </FormGroup>
                        </Col>
                      )}
                      {createInvestmentFormData?.savingFrequency === "WEEKLY" && (
                        <Col md="6">
                          <FormGroup>
                            <label className="form-label">Set Weekly Contribution Day</label>

                            <RSelect
                              options={weeksOptions}
                              value={
                                weeksOptions.filter(
                                  (value) => value === createInvestmentFormData?.weeklyContributionDay
                                )[0]
                              }
                              invalid={
                                singleProduct?.properties?.hasSavingFrequency &&
                                createInvestmentFormData.savingFrequency === "WEEKLY" &&
                                touched
                              }
                              onChange={(e) => handleInvestmentSelectChange(e, "weeklyContributionDay")}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </>
                  )}
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Interest Receipt Option</label>
                      <select
                        className={`form-control ${
                          createInvestmentFormData.interestReceiptOption === "" && touched ? "is-invalid" : ""
                        }`}
                        name="interestReceiptOption"
                        onChange={handleInvestmentInputChange}
                        value={createInvestmentFormData?.interestReceiptOption}
                      >
                        <option value="" disabled hidden>
                          Select interest receipt option
                        </option>
                       {singleProduct?.properties?.interestOptions &&
  Object.entries(singleProduct.properties.interestOptions ?? {}).map(
    ([key, value]) =>
      value === true &&
      key?.includes("Backend") &&
      filterIntRecOpt(
        createInvestmentFormData?.tenor === 0
          ? moment(createInvestmentFormData.actualMaturityDate).diff(recentDate, "days")
          : singleProduct?.tenors?.find(
              (item) => item?.id === createInvestmentFormData?.tenor
            )?.tenorDays
      )?.includes(key) && (
        <option
          key={key}
          value={convertReadableTextForInterestOptions(key)}
          style={{ textTransform: "capitalize" }}
        >
          {convertReadableTextForInterestOptions(key).toLowerCase()}
        </option>
      )
  )}

                      </select>
                      {/* <RSelect
                        placeholder="Select interest receipt option"
                        options={interestReceiptOptions}
                        value={interestReceiptOptions?.filter(
                          ({ value }) => value === createInvestmentFormData?.interestReceiptOption
                        )}
                        onChange={(e) => handleInvestmentSelectChange(e, "interestReceiptOptions")}
                        ref={register({ required: true })}
                      />

                      {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  {singleProduct?.properties?.hasSavingFrequency && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Contribution Value</label>
                        <div className="input-group">
                          <div className="input-group-prepend curr-icon">
                            {getCurrencyIcon(createInvestmentFormData.currency)}
                          </div>
                          <input
                            type="number"
                            name="contributionValue"
                            value={createInvestmentFormData.contributionValue}
                            onChange={handleInvestmentInputChange}
                            className={`form-control ${createInvestmentFormData.currency !== "" && "curr-input"}`}
                            disabled={!singleProduct?.properties?.hasSavingFrequency}
                          />
                        </div>
                        {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  {singleProduct?.properties?.hasDirectDebit && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Direct Debit</label>
                        <Col>
                          <div className="custom-control custom-control-sm custom-checkbox">
                            <input
                              type="checkbox"
                              name="directDebit"
                              disabled={!singleProduct?.properties?.hasDirectDebit}
                              defaultChecked={createInvestmentFormData?.directDebit} // use state value
                              className="custom-control-input form-control"
                              onChange={(e) => handleInvestmentCheckboxChange(e)}
                              id="directDebit"
                            />
                            <label className="custom-control-label" htmlFor="directDebit">
                              Activate Direct Debit?
                            </label>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                  )}
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Investment Interest Rate</label>
                      <input
                        type="number"
                        name="interestRate"
                        value={createInvestmentFormData?.interestRate}
                        placeholder="Enter Investment Interest Rate"
                        onChange={(e) => handleInvestmentInputChange(e)}
                        className={`form-control ${
                          createInvestmentFormData.interestRate <
                            fetchIntRate(createInvestmentFormData.interestReceiptOption) &&
                          createInvestmentFormData.requestConcession
                            ? "is-invalid"
                            : ""
                        }`}
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      {createInvestmentFormData.interestRate <
                        fetchIntRate(createInvestmentFormData.interestReceiptOption) &&
                      createInvestmentFormData.requestConcession ? (
                        <span className="invalid">Input interest rate should be greater than preset limit</span>
                      ) : createInvestmentFormData.interestRate >
                          fetchIntRate(createInvestmentFormData.interestReceiptOption) &&
                        !createInvestmentFormData.requestConcession ? (
                        <span className="invalid">Input interest rate should not be greater than preset limit</span>
                      ) : (
                        <></>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Request Concession</label>
                      <Col>
                        <div className="custom-control custom-control-sm custom-checkbox">
                          <input
                            type="checkbox"
                            name="requestConcession"
                            defaultChecked={createInvestmentFormData?.requestConcession} // use state value
                            className="custom-control-input form-control"
                            onChange={(e) => handleInvestmentCheckboxChange(e)}
                            id="requestConcession"
                          />
                          <label className="custom-control-label" htmlFor="requestConcession">
                            Request Concession?
                          </label>
                        </div>
                      </Col>
                    </FormGroup>
                  </Col>
                  {createInvestmentFormData.requestConcession === true && (
                    <>
                      {/* <Col md="6">
                        <FormGroup>
                          <label className="form-label">Interest Rate</label>
                          <input
                            type="text"
                            name="interestRate"
                            value={createInvestmentFormData?.interestRate}
                            onChange={handleInvestmentInputChange}
                            className="form-control"
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                        </FormGroup>
                      </Col> */}
                      <Col md="6">
                        <FormGroup>
                          <label className="form-label">Upload Approval Document</label>
                          <input
                            type="file"
                            name="approvalConcessionDocumentImage"
                            onChange={(e) => handleInvestmentFileChange(e, "approvalConcessionDocumentImage")}
                            className={`form-control ${
                              createInvestmentFormData.approvalConcessionDocumentImage === "" &&
                              createInvestmentFormData.requestConcession &&
                              fileErr.approvalConcessionDocumentImage
                                ? "is-invalid"
                                : ""
                            }`}
                            ref={register({
                              required: "This field is required",
                            })}
                          />
                          {createInvestmentFormData.approvalConcessionDocumentImage === "" &&
                            createInvestmentFormData.requestConcession &&
                            fileErr.approvalConcessionDocumentImage && (
                              <span className="invalid">Image must be .jpeg and not more than 2MB</span>
                            )}
                        </FormGroup>
                      </Col>
                    </>
                  )}
                  {singleProduct?.properties?.allowsMonthlyDraw && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Number Of Tickets</label>
                        <input
                          type="number"
                          name="numberOfTickets"
                          value={updateNumOfTickets(
                            singleProduct?.properties?.hasTargetAmount
                              ? createInvestmentFormData.targetAmount
                              : Number(createInvestmentFormData.amount)
                          )}
                          onChange={handleInvestmentInputChange}
                          className="form-control"
                          ref={register({
                            required: "This field is required",
                          })}
                        />
                        {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  {singleProduct?.properties?.acceptsRollover && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Auto Renew Investment</label>
                        <RSelect
                          options={[
                            { label: "YES", value: true },
                            { label: "NO", value: false },
                          ]}
                          value={
                            [
                              { label: "YES", value: true },
                              { label: "NO", value: false },
                            ].filter(({ value }) => value === createInvestmentFormData?.autoRenew)[0]
                          }
                          onChange={(e) => handleInvestmentSelectChange(e, "autoRenew")}
                        />
                        {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  {singleProduct?.properties?.allowsLiquidation && (
                    <Col md="6">
                      <FormGroup>
                        <label className="form-label">Allow Liquidation</label>
                        <RSelect
                          options={[
                            { label: "YES", value: true },
                            { label: "NO", value: false },
                          ]}
                          value={
                            [
                              { label: "YES", value: true },
                              { label: "NO", value: false },
                            ].filter(({ value }) => value === createInvestmentFormData?.allowsLiquidation)[0]
                          }
                          onChange={(e) => handleInvestmentSelectChange(e, "allowsLiquidation")}
                        />
                        {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                      </FormGroup>
                    </Col>
                  )}
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Upload Payment Proof</label>
                      <input
                        type="file"
                        name="paymentProofImage"
                        onChange={(e) => handleInvestmentFileChange(e, "paymentProofImage")}
                        className={`form-control ${
                          createInvestmentFormData.paymentProofImage === "" && fileErr.paymentProofImage
                            ? "is-invalid"
                            : ""
                        }`}
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {createInvestmentFormData.paymentProofImage === "" && fileErr.paymentProofImage && (
                        <span className="invalid">Image must be .jpeg and not more than 2MB</span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="12" className="d-flex align-center justify-content-end">
                    <Button
                      color="primary"
                      type="button"
                      size="md"
                      onClick={(e) => {
                        e.preventDefault();
                        setComputeInvestment(true);
                        setTouched(true);
                      }}
                    >
                      Compute Investment
                    </Button>
                  </Col>
                  {computeInvestment && (
                    <Col md="12">
                      <div className="d-flex justify-content-between w-100 mt-4 mb-4">
                        <div>
                          <p>Investment Rate: </p>
                          <p>{createInvestmentFormData.interestRate}%</p>
                        </div>
                        <div>
                          <p>Value Date: </p>
                          <p>{createInvestmentFormData.dateCreated} </p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between w-100 mt-4 mb-4">
                        <div>
                          <p>End Date: </p>
                          <p>{createInvestmentFormData.planSummary?.endDate} </p>
                        </div>
                        <div>
                          <p>Calculated Interest: </p>
                          <p className="text-right">
                            {getCurrencyIcon(createInvestmentFormData.currency)}{" "}
                            {createInvestmentFormData.planSummary?.calculatedInterest}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between w-100 mt-4 mb-4">
                        <div>
                          <p>Withholding Tax: </p>
                          <p>
                            {getCurrencyIcon(createInvestmentFormData.currency)}{" "}
                            {Math.round(
                              createInvestmentFormData.planSummary?.calculatedInterest *
                                (createInvestmentFormData.planSummary?.withholdingTax / 100) *
                                100 +
                                Number.EPSILON
                            ) / 100}
                          </p>
                        </div>
                        <div>
                          <p>Payment At Maturity: </p>
                          <p className="text-right">
                            {getCurrencyIcon(createInvestmentFormData.currency)}{" "}
                            {createInvestmentFormData.planSummary?.paymentMaturity}
                          </p>
                        </div>
                      </div>
                      <Col md="12" className="d-flex align-center justify-content-end">
                        <Button
                          color="warning"
                          size="md"
                          type="button"
                          className="mr-3"
                          onClick={(e) => {
                            e.preventDefault();
                            setCreateInvestmentFormData(createInvestmentInitialForm);
                            setModal({ investment: false });
                            setComputeInvestment(false);
                            setTouched(false);
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          color="primary"
                          type="submit"
                          disabled={!validateCreateInvestment()}
                          size="md"
                          onClick={createInvestmentSubmit}
                        >
                          Create Investment
                        </Button>
                      </Col>
                    </Col>
                  )}
                </Form>
              </div>
            </InvestmentWrapper>
          </ModalBody>
        </Modal>
        <VerifyBvnModal
          isOpen={verifyBvnModal}
          toggle={() => setVerifyBvnModal(false)}
        />
      </Content>
    </React.Fragment>
  );
};

const InvestmentWrapper = styled.div`
  padding: 0.5rem;
  .curr-icon {
    position: absolute;
    margin-top: 7px;
    margin-left: 20px;
    z-index: 10;
  }
  .curr-input {
    padding-left: 32px;
  }
`;
